export const getCampaignUserMediasInstagram = {
  data: [
    {
      localizacao: {},
      usuario: {
        collab: {},
        id: 'instagram|17841401601466718',
        username: 'dannyborboletando',
        foto: 'https://scontent.fmaa10-1.fna.fbcdn.net/v/t51.2885-15/363810689_3404320576496937_8273623592339526500_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=86c713&_nc_eui2=AeFx_5Mv5WCqHTOF2hXIN_4bTnTs4D_1zH5OdOzgP_XMflrdM62tmZA7W9E2j5HAcVs&_nc_ohc=bMe3tlkL4yIAX8dARX4&_nc_ht=scontent.fmaa10-1.fna&edm=AL-3X8kEAAAA&oh=00_AfAAaKWk7BjSZCp6inrT7UKuR1_l4P3NVWOm4RAe-B7Nbg&oe=64D93A80',
        nome: 'Daniela Roldao✨',
      },
      tags: [
        'nivealip',
        'nivea',
        'nivealipbalm',
        'reelsforyou',
        'reelvideos',
        'reelsbrasil',
        'reelsinstagram',
        'mondayreels',
        'mondaymorning',
        'mondaymood',
        'lipgloss',
        'lipscare',
        'lips',
        'labios',
        'cuidado',
        'reelsitfeelsit',
        'reelkrofeelkro',
        'reelsviral',
        'reelsinsta',
        'reelsindia',
      ],
      mentions: ['niveabrasil'],
      ad: false,
      links: [],
      upvotes: 18,
      comentarios: 13,
      hasOCRMetrics: false,
      _id: '64c7ab089166f2a3b971bb2b',
      origem: 'instagram',
      uid: '17946597914551157',
      __v: 0,
      captura: 'manual',
      criadoEm: '2023-07-31T12:34:06.000Z',
      legenda:
        'Para ter lábios saudáveis e sem rachaduras é preciso ter uma rotina de cuidados, como por exemplo, sempre hidratar os lábios. Para isso, é preciso beber bastante água e sempre fazer uso de hidratante labial.\n\nAliás dona @niveabrasil dominou bonito esse mini ranking \n\nVem ver quais são meus protetores labiais do momento !\n\n#nivealip #nivea #nivealipbalm #reelsforyou #reelvideos #reelsbrasil #reelsinstagram❤️💯 #mondayreels #mondaymorning #mondaymood #lipgloss #lipscare #lips #labios #cuidado #reelsitfeelsit #reelkrofeelkro #reelsviral #reelsinsta #reelsindia',
      link: 'https://www.instagram.com/reel/CvXJXcYgBQl/',
      metadados: {
        idFacebook: '17946597914551157',
        isEstimated: true,
        engagement: 41,
        plays: 1264,
        saved: 10,
        reach: 985,
        effective_reach: 0.057410969283674305,
        tax_engagement: 0.03243670886075949,
        comments_by_like: 0.7222222222222222,
        comments_rate: 0.010284810126582278,
      },
      obtidoEm: '2023-07-31T12:37:27.992Z',
      referencias: [
        {
          id: '64af130248148a12db5d0ab7',
          type: 'monitoring',
          startDate: '2023-07-17T03:00:00.000Z',
          isInfluencer: true,
          brandUsername: 'niveabrasil',
          monitoringTag: 'nivealip',
          status: 'none',
          gamification: false,
        },
      ],
      tipo: 'video',
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17946597914551157/video_dannyborboletando_17946597914551157.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17946597914551157/video_dannyborboletando_17946597914551157.mp4',
          width: 480,
          height: 480,
        },
      },
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17946597914551157/image_dannyborboletando_17946597914551157.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17946597914551157/image_dannyborboletando_17946597914551157.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17946597914551157/image_dannyborboletando_17946597914551157.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-10T11:03:54.521Z',
      obtidoPor: 'facebook',
    },
    {
      localizacao: {},
      usuario: {
        collab: {},
        id: 'instagram|17841401601466718',
        username: 'dannyborboletando',
        foto: 'https://scontent.fmaa10-1.fna.fbcdn.net/v/t51.2885-15/354573297_760238149170677_6056238034495836670_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=86c713&_nc_eui2=AeGeINEiRZkps2ojwlBw6u9pM7b66xrsIUcztvrrGuwhR2uITMh3xvx9finl2fpVF7c&_nc_ohc=H-90DjJl3GcAX9nVw9-&_nc_ht=scontent.fmaa10-1.fna&edm=AL-3X8kEAAAA&oh=00_AfAOd5r6IpXSEXvHsUa4LG2mnYDgTxHKRVjc42J1JUYKrQ&oe=64CC38D3',
        nome: 'Daniela Roldao✨',
      },
      tags: [],
      mentions: [],
      ad: true,
      links: [],
      upvotes: 0,
      comentarios: 0,
      hasOCRMetrics: false,
      _id: '64c6b0859166f2a3b95664e9',
      origem: 'instagram',
      uid: '17899287503827688',
      criadoEm: '2023-07-30T18:33:56.000Z',
      detection: null,
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17899287503827688/image_resolucaoPadrao.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17899287503827688/image_resolucaoPadrao.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17899287503827688/image_resolucaoPadrao.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-07-31T13:48:13.385Z',
      legenda:
        'Vocês descansam e eu trabalho rs \nAqui roteirizando os próximos conteúdos \nAaaah aliás amanhã tem conteúdo inédito no reels! E nós stories também  @niveabrasil',
      link: '',
      metadados: {
        exits: 9,
        impressions: 37,
        reach: 37,
        replies: 1,
        taps_forward: 27,
        taps_back: 4,
        completedVideosRate: 0.02702702702702703,
        effective_reach: 0.002156805596036141,
        tax_engagement: 0.13513513513513514,
        idFacebook: '17899287503827688',
        hourOnline: 19.237546944444443,
      },
      metricsAvailable: true,
      obtidoEm: '2023-07-30T18:48:37.632Z',
      referencias: [
        {
          id: '64af130248148a12db5d0ab7',
          type: 'referenceType',
          status: 'none',
          isInfluencer: true,
          gamification: false,
        },
      ],
      tipo: 'video_stories',
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17899287503827688/video_resolucaoPadrao.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17899287503827688/video_resolucaoPadrao.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      localizacao: {},
      usuario: {
        collab: {},
        id: 'instagram|17841401601466718',
        username: 'dannyborboletando',
        foto: 'https://scontent.fmaa10-1.fna.fbcdn.net/v/t51.2885-15/363810689_3404320576496937_8273623592339526500_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=86c713&_nc_eui2=AeFx_5Mv5WCqHTOF2hXIN_4bTnTs4D_1zH5OdOzgP_XMflrdM62tmZA7W9E2j5HAcVs&_nc_ohc=bMe3tlkL4yIAX8dARX4&_nc_ht=scontent.fmaa10-1.fna&edm=AL-3X8kEAAAA&oh=00_AfAAaKWk7BjSZCp6inrT7UKuR1_l4P3NVWOm4RAe-B7Nbg&oe=64D93A80',
        nome: 'Daniela Roldao✨',
      },
      tags: [
        'barbiethemovie',
        'barbie',
        'barbiestyle',
        'barbiedoll',
        'barbiegirl',
        'nivea',
        'lipstickswatch',
        'lipaugmentation',
        'lipscare',
        'lipfiller',
        'lipstickjunkie',
        'lipstickaddict',
        'labios',
        'labiosthetique',
        'reelsviral',
        'reelsinsta',
        'reelvideos',
        'publi',
        'ad',
        'reelsinstagram',
        'reelkarofeelkaro',
        'reelsvideo',
        'makeuplook',
        'makeupart',
        'makeupartist',
        'videos',
        'vidgram',
        'beautygirl',
        'beautyaddict',
      ],
      mentions: ['niveabrasil'],
      ad: true,
      links: [],
      upvotes: 28,
      comentarios: 15,
      hasOCRMetrics: false,
      _id: '64c3b5a09166f2a3b98b0563',
      origem: 'instagram',
      uid: '18002554237790189',
      __v: 0,
      criadoEm: '2023-07-28T12:05:52.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18002554237790189/image_dannyborboletando_18002554237790189.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18002554237790189/image_dannyborboletando_18002554237790189.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18002554237790189/image_dannyborboletando_18002554237790189.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-10T11:03:54.672Z',
      legenda:
        'Maquiagem perfeita. Humor perfeito !\n\nNIVEA HIDRATANTE LABIAL HIDRA COLOR 2 EM 1 NUDE\n\nProtege os lábios contra o ressecamento e promove hidratação de longa duração\n\nCor suave sem craquelar.\n\nHidratação Duradoura.\n\nCom manteiga de karité e óleo de amêndoa orgânica.\n\nLivre de óleo mineral.\n\nAplique várias camadas para aumentar a intensidade da cor.\n\n@niveabrasil \n\n#barbiethemovie #barbie #barbiestyle #barbiedoll #barbiegirl #nivea #lipstickswatch #lipaugmentation #lipscare #lipfiller #lipstickjunkie #lipstickaddict #labios #labiosthetique #reelsviral #reelsinsta #reelvideos #publi #ad #reelsinstagram❤️💯 #reelkarofeelkaro❤ #reelsvideo #makeuplook #makeupart #makeupartist #videos #vidgram #beautygirl #beautyaddict',
      link: 'https://www.instagram.com/reel/CvPYEsbAlU9/',
      metadados: {
        idFacebook: '18002554237790189',
        isEstimated: true,
        engagement: 51,
        plays: 1184,
        saved: 8,
        reach: 993,
        effective_reach: 0.05787725126770414,
        tax_engagement: 0.04307432432432432,
        comments_by_like: 0.5357142857142857,
        comments_rate: 0.01266891891891892,
      },
      obtidoEm: '2023-07-28T12:33:33.795Z',
      obtidoPor: 'facebook',
      referencias: [
        {
          id: '64af130248148a12db5d0ab7',
          type: 'monitoring',
          startDate: '2023-07-17T03:00:00.000Z',
          isInfluencer: true,
          brandUsername: 'niveabrasil',
          monitoringTag: 'nivealip',
          status: 'none',
          gamification: true,
        },
      ],
      tipo: 'video',
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 480,
          height: 480,
        },
      },
    },
    {
      localizacao: {},
      usuario: {
        collab: {},
        id: 'instagram|17841401601466718',
        username: 'dannyborboletando',
        foto: 'https://scontent.fmaa10-1.fna.fbcdn.net/v/t51.2885-15/363810689_3404320576496937_8273623592339526500_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=86c713&_nc_eui2=AeFx_5Mv5WCqHTOF2hXIN_4bTnTs4D_1zH5OdOzgP_XMflrdM62tmZA7W9E2j5HAcVs&_nc_ohc=bMe3tlkL4yIAX8dARX4&_nc_ht=scontent.fmaa10-1.fna&edm=AL-3X8kEAAAA&oh=00_AfAAaKWk7BjSZCp6inrT7UKuR1_l4P3NVWOm4RAe-B7Nbg&oe=64D93A80',
        nome: 'Daniela Roldao✨',
      },
      tags: [
        'tbt',
        'tbthursday',
        'tbt',
        'tbt',
        'tbt',
        'lipsync',
        'lipstickswatch',
        'lipscare',
        'lipstickjunkie',
        'lipstickday',
        'lips',
        'hidratacion',
        'boca',
        'nivea',
        'hidrata',
        'labios',
        'lipscrub',
        'makeupart',
        'makeupartistworldwide',
        'beproudofyourself',
        'beauty',
      ],
      mentions: ['niveabrasil'],
      ad: false,
      links: [],
      upvotes: 19,
      comentarios: 8,
      hasOCRMetrics: false,
      _id: '64c2720d9166f2a3b9534338',
      origem: 'instagram',
      uid: '17921682668757804',
      __v: 0,
      criadoEm: '2023-07-27T13:31:34.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17921682668757804/image_dannyborboletando_17921682668757804.webp',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17921682668757804/image_dannyborboletando_17921682668757804.webp',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/17921682668757804/image_dannyborboletando_17921682668757804.webp',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-10T11:03:54.710Z',
      legenda:
        'Inédita pra vocês,mas #tbt🔙📸 pra mim do novo @niveabrasil NIVEA HIDRATANTE LABIAL HIDRA COLOR 2 EM 1 NUDE.\n\nQue protege os lábios contra o ressecamento e promove hidratação de longa duração.\n\n♡Cor suave sem craquelar.\n♡Hidratação Duradoura.\n♡Com manteiga de karité e óleo de amêndoa orgânica.\n♡Livre de óleo mineral.\n♡Aplique várias camadas para aumentar a intensidade da cor.\n\nE sim fica lindão naquela make de arrasar e aí já escolheu o seu @niveabrasil hidra color favorito?\n\n@niveabrasil\n\n#tbthursday #tbt🔙📸 #tbt #tbt🔙 #lipsync #lipstickswatch #lipscare #lipstickjunkie #lipstickday #lips #hidratacion #boca #nivea #hidratação #labios #lipscrub #makeupart #makeupartistworldwide #beproudofyourself #beauty',
      link: 'https://www.instagram.com/p/CvM9wxvAiLR/',
      metadados: {
        idFacebook: '17921682668757804',
        isEstimated: false,
        engagement: 30,
        saved: 3,
        impressions: 297,
        reach: 291,
        effective_reach: 0.016961007169085506,
        tax_engagement: 0.10101010101010101,
        comments_by_like: 0.42105263157894735,
        comments_rate: 0.026936026936026935,
      },
      obtidoEm: '2023-07-27T13:32:59.344Z',
      obtidoPor: 'facebook',
      referencias: [
        {
          id: '64af130248148a12db5d0ab7',
          type: 'monitoring',
          startDate: '2023-07-17T03:00:00.000Z',
          isInfluencer: true,
          brandUsername: 'niveabrasil',
          monitoringTag: 'nivealip',
          status: 'none',
          gamification: true,
        },
      ],
      tipo: 'imagem',
    },
    {
      localizacao: {},
      usuario: {
        collab: {},
        id: 'instagram|17841401601466718',
        username: 'dannyborboletando',
        foto: 'https://scontent.fmaa10-1.fna.fbcdn.net/v/t51.2885-15/363810689_3404320576496937_8273623592339526500_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=86c713&_nc_eui2=AeFx_5Mv5WCqHTOF2hXIN_4bTnTs4D_1zH5OdOzgP_XMflrdM62tmZA7W9E2j5HAcVs&_nc_ohc=bMe3tlkL4yIAX8dARX4&_nc_ht=scontent.fmaa10-1.fna&edm=AL-3X8kEAAAA&oh=00_AfAAaKWk7BjSZCp6inrT7UKuR1_l4P3NVWOm4RAe-B7Nbg&oe=64D93A80',
        nome: 'Daniela Roldao✨',
      },
      tags: [
        'lipglosspoppin',
        'lipsync',
        'lipgloss',
        'lipfiller',
        'lipstickday',
        'lipscare',
        'lipstickjunkie',
        'lipbalms',
        'lipbalm',
        'balm',
        'protetorsolar',
        'protetorlabial',
        'protetorlabialnivea',
        'nivea',
        'nudenails',
        'nudelip',
        'nudeln',
        'inverno',
        'winter',
        'wednesday',
        'beaut',
        'beauty',
        'liptint',
      ],
      mentions: ['niveabrasil'],
      ad: false,
      links: [],
      upvotes: 11,
      comentarios: 5,
      hasOCRMetrics: false,
      _id: '64c143ce9166f2a3b95c97ee',
      origem: 'instagram',
      uid: '18374207842012071',
      __v: 0,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/carousel_0_dannyborboletando_18374207842012071.webp',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/carousel_1_dannyborboletando_18374207842012071.webp',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/carousel_2_dannyborboletando_18374207842012071.webp',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/carousel_3_dannyborboletando_18374207842012071.webp',
        },
      ],
      criadoEm: '2023-07-26T15:34:28.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/image_dannyborboletando_18374207842012071.webp',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/image_dannyborboletando_18374207842012071.webp',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841401601466718/18374207842012071/image_dannyborboletando_18374207842012071.webp',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-10T11:03:54.772Z',
      legenda:
        'NIVEA HIDRATANTE LABIAL HIDRA COLOR 2 EM 1 NUDE\n\nProtege os lábios contra o ressecamento e promove hidratação de longa duração \n\n@niveabrasil \n\n#lipglosspoppin #lipsync #lipgloss #lipfiller #lipstickday #lipscare #lipstickjunkie #lipbalms #lipbalm #balm #protetorsolar #protetorlabial #protetorlabialnivea #nivea #nudenails #nudelip #nudeln #inverno #winter #wednesday #beauté #beauty #liptint',
      link: 'https://www.instagram.com/p/CvKnCFQA53R/',
      metadados: {
        idFacebook: '18374207842012071',
        isEstimated: false,
        engagement: 19,
        saved: 3,
        impressions: 225,
        reach: 200,
        effective_reach: 0.011657049600746051,
        tax_engagement: 0.08444444444444445,
        comments_by_like: 0.45454545454545453,
        comments_rate: 0.022222222222222223,
      },
      obtidoEm: '2023-07-26T16:03:19.749Z',
      obtidoPor: 'facebook',
      referencias: [
        {
          id: '64af130248148a12db5d0ab7',
          type: 'monitoring',
          startDate: '2023-07-17T03:00:00.000Z',
          isInfluencer: true,
          brandUsername: 'niveabrasil',
          monitoringTag: 'nivealip',
          status: 'none',
          gamification: true,
        },
      ],
      tipo: 'carousel',
    },
  ],
  total: 5,
}

export const getYoutubeMidias = [
  {
    kind: 'youtube#video',
    etag: 'j2nuZKFmuCoCVZNuo0TnCjo3ex8',
    id: '0b0IEhTYZNM',
    snippet: {
      publishedAt: '2023-08-21T00:00:07Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Aprenda a fazer Brigadeiro sabor Torta de limão',
      description:
        '🍋Brigadeiro torta de limão \n🍋INGREDIENTES\n* 395g condensado\n* 1 colher de sopa de manteiga \n* 15g de pó para preparo de sobremesa sabor limão Mavalério\n* Raspas de  limão siciliano\n* Raspas de limão Tahiti \n* 100g de Biscoitos ao leite ou maisena triturados \n* Açúcar colorido (branco) Mavalério para bolear os doces \n🍋MODO DE PREPARO\n* Rale a casca do limão siciliano tomando cuidado para não remover a parte branca e reserve..\n* Em uma panela, deposite o leite condensado a manteiga e os biscoitos \n* Leve ao fogo baixo, mexendo sempre, até desgrudar do fundo da panela..\n* Acrescente o pó para preparo de sobremesa sabor limão e em seguida as raspas \n* despeje  a massa num prato e cubra imediatamente com plástico filme..\n* Espere o brigadeiro esfriar por completo antes de modelar..\n* Passe no açúcar e decore com raspas de limão. \n\n\nPara as forminhas de chocolate usei cobertura Premium Mavalerio sabor chocolate branco.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/0b0IEhTYZNM/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/0b0IEhTYZNM/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/0b0IEhTYZNM/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/0b0IEhTYZNM/sddefault.jpg',
          width: 640,
          height: 480,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Aprenda a fazer Brigadeiro sabor Torta de limão',
        description:
          '🍋Brigadeiro torta de limão \n🍋INGREDIENTES\n* 395g condensado\n* 1 colher de sopa de manteiga \n* 15g de pó para preparo de sobremesa sabor limão Mavalério\n* Raspas de  limão siciliano\n* Raspas de limão Tahiti \n* 100g de Biscoitos ao leite ou maisena triturados \n* Açúcar colorido (branco) Mavalério para bolear os doces \n🍋MODO DE PREPARO\n* Rale a casca do limão siciliano tomando cuidado para não remover a parte branca e reserve..\n* Em uma panela, deposite o leite condensado a manteiga e os biscoitos \n* Leve ao fogo baixo, mexendo sempre, até desgrudar do fundo da panela..\n* Acrescente o pó para preparo de sobremesa sabor limão e em seguida as raspas \n* despeje  a massa num prato e cubra imediatamente com plástico filme..\n* Espere o brigadeiro esfriar por completo antes de modelar..\n* Passe no açúcar e decore com raspas de limão. \n\n\nPara as forminhas de chocolate usei cobertura Premium Mavalerio sabor chocolate branco.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT51M57S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '961',
      likeCount: '169',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '8',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/0b0IEhTYZNM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'ayiAHjtK84xf9D77za1Vv-0zcCc',
    id: 'IIqZneQSQnw',
    snippet: {
      publishedAt: '2023-08-17T01:00:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo bombom tipo prestígio para fazer e vender.',
      description:
        'Esse vídeo é para você aprender passo a passo o preparo de bolo bombom com várias técnicas para agilizar a produção. \n\nMassa: \n2 ovos \n100ml de óleo \n120g de açúcar \n80g de chocolate em pó 70%cacau Mavalério\n200ml de leite \n15h de fermento em pó \n220g de farinha de trigo \n\nMisture muito bem, unte uma forma de até 28cm diâmetro e leve ao micro potência alta por 4 a 7 minutos . \nDesenforme e esfarele. \n\nRecheio \n395g de leite condensado \n80 a 100g de coco seco \nMisture bem e reserve. \n\nPara as casquinhas usei Cobertura Premium blend Mavalério \nForma de 3 partes  cod1339 \n\nValidade 3 dias \n\nFaz e me conta o que achou dessa delícia?!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/IIqZneQSQnw/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/IIqZneQSQnw/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/IIqZneQSQnw/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/IIqZneQSQnw/sddefault.jpg',
          width: 640,
          height: 480,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo bombom tipo prestígio para fazer e vender.',
        description:
          'Esse vídeo é para você aprender passo a passo o preparo de bolo bombom com várias técnicas para agilizar a produção. \n\nMassa: \n2 ovos \n100ml de óleo \n120g de açúcar \n80g de chocolate em pó 70%cacau Mavalério\n200ml de leite \n15h de fermento em pó \n220g de farinha de trigo \n\nMisture muito bem, unte uma forma de até 28cm diâmetro e leve ao micro potência alta por 4 a 7 minutos . \nDesenforme e esfarele. \n\nRecheio \n395g de leite condensado \n80 a 100g de coco seco \nMisture bem e reserve. \n\nPara as casquinhas usei Cobertura Premium blend Mavalério \nForma de 3 partes  cod1339 \n\nValidade 3 dias \n\nFaz e me conta o que achou dessa delícia?!',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1H7M42S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '1431',
      likeCount: '199',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '16',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/IIqZneQSQnw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'LciqmMJ9IKxkICceFfxF87pt1vY',
    id: '5dFz-vjrtl4',
    snippet: {
      publishedAt: '2023-08-12T01:26:22Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo cremoso de chocolate feito em 5 minutos 😉',
      description:
        'Você acredita que eu fiz a massa desse bolo em 5 minutos? \n\nNão?!!!! \n\nEntão assiste essa live e depois comenta aqui o que vc achou! \n\nAhh, já salva a receita para não perder! \n\nMassa \n2 ovos (100g) \n100g de açúcar \n50g de chocolate em pó 70%cacau\n100ml de óleo \n120ml de leite \n12g de fermento em pó Dr Oetker \n200g de farinha de trigo \n\nMisture tudo, coloque em forma untada e leve ao microondas potência alta por 5 a 7 minutos.\n\nCobertura \n400ml de leite \n20g de amido \n50g de chocolate em pó 70% cacau Mavalério \n200g de Cobertura Premium Mavalério (usei a Blend)',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/5dFz-vjrtl4/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/5dFz-vjrtl4/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/5dFz-vjrtl4/hqdefault.jpg',
          width: 480,
          height: 360,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo cremoso de chocolate feito em 5 minutos 😉',
        description:
          'Você acredita que eu fiz a massa desse bolo em 5 minutos? \n\nNão?!!!! \n\nEntão assiste essa live e depois comenta aqui o que vc achou! \n\nAhh, já salva a receita para não perder! \n\nMassa \n2 ovos (100g) \n100g de açúcar \n50g de chocolate em pó 70%cacau\n100ml de óleo \n120ml de leite \n12g de fermento em pó Dr Oetker \n200g de farinha de trigo \n\nMisture tudo, coloque em forma untada e leve ao microondas potência alta por 5 a 7 minutos.\n\nCobertura \n400ml de leite \n20g de amido \n50g de chocolate em pó 70% cacau Mavalério \n200g de Cobertura Premium Mavalério (usei a Blend)',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT41M34S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '2645',
      likeCount: '306',
      dislikeCount: '1',
      favoriteCount: '0',
      commentCount: '38',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/5dFz-vjrtl4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'OO1l5BiONAzb-GH03ihcEsuNXBA',
    id: 'V4TEx5It7UA',
    snippet: {
      publishedAt: '2023-08-10T18:35:04Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Docinhos de festa, Cerejas encapadas',
      description:
        '🍒Cerejas encapadas \n\n🍒395g de leite condensado \n🍒50ml de licor de cerejas \n🍒200g de cobertura Premium sabor chocolate branco Mavalério\n🍒10g de pó para preparo de sobremesa sabor morango Mavalério\n\n🍒Cerejas para rechear \n🍒Cobertura Premium sabor chocolate branco Mavalério para banhar \n🍒Açúcar colorido Rosa mil cores Mavalério',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/V4TEx5It7UA/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/V4TEx5It7UA/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/V4TEx5It7UA/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/V4TEx5It7UA/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/V4TEx5It7UA/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Docinhos de festa, Cerejas encapadas',
        description:
          '🍒Cerejas encapadas \n\n🍒395g de leite condensado \n🍒50ml de licor de cerejas \n🍒200g de cobertura Premium sabor chocolate branco Mavalério\n🍒10g de pó para preparo de sobremesa sabor morango Mavalério\n\n🍒Cerejas para rechear \n🍒Cobertura Premium sabor chocolate branco Mavalério para banhar \n🍒Açúcar colorido Rosa mil cores Mavalério',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT47M38S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '669',
      likeCount: '86',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '11',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/V4TEx5It7UA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'N-5iEiqlvd-3Xla4AXIeLfYHQLk',
    id: 'HdJFvhd7msM',
    snippet: {
      publishedAt: '2023-08-02T23:00:09Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Recheio Caramelo de batedeira para bombons, trufas e bolos no pote.',
      description:
        'Esse recheio além de delicioso e muito fácil de preparar, tem validade de 10 dias fora de geladeira!\nUse para rechear bombons, bolo no pote, trufas, barrinhas de chocolate e muito mais 🍫\n\n🍡300g de açúcar Refinado ou cristal \n🍡80g de manteiga \n🍡200g de creme de leite \n\n🍡Leve o açúcar ao fogo até derreter e ficar com cor de guaraná, acrescente a manteiga e mexa bem. Em seguida acrescente o creme de leite e mexa bem. Leve a batedeira e bata por 3 minutos! E prontinho…',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/HdJFvhd7msM/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/HdJFvhd7msM/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/HdJFvhd7msM/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/HdJFvhd7msM/sddefault.jpg',
          width: 640,
          height: 480,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Recheio Caramelo de batedeira para bombons, trufas e bolos no pote.',
        description:
          'Esse recheio além de delicioso e muito fácil de preparar, tem validade de 10 dias fora de geladeira!\nUse para rechear bombons, bolo no pote, trufas, barrinhas de chocolate e muito mais 🍫\n\n🍡300g de açúcar Refinado ou cristal \n🍡80g de manteiga \n🍡200g de creme de leite \n\n🍡Leve o açúcar ao fogo até derreter e ficar com cor de guaraná, acrescente a manteiga e mexa bem. Em seguida acrescente o creme de leite e mexa bem. Leve a batedeira e bata por 3 minutos! E prontinho…',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M56S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '1184',
      likeCount: '130',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '7',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/HdJFvhd7msM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'KTMutahQrer-xLuA7GXgNhL9vvc',
    id: 'PKy1sWIc0i0',
    snippet: {
      publishedAt: '2023-07-29T11:52:55Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Receita de cocada',
      description:
        '🥥Ingredientes \n200g de açúcar \n150g de coco seco \nCorante em Gel rosa a gosto \n200g de leite condensado \n100ml de água \nValidade 10dias',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/PKy1sWIc0i0/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/PKy1sWIc0i0/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/PKy1sWIc0i0/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/PKy1sWIc0i0/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/PKy1sWIc0i0/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Receita de cocada',
        description:
          '🥥Ingredientes \n200g de açúcar \n150g de coco seco \nCorante em Gel rosa a gosto \n200g de leite condensado \n100ml de água \nValidade 10dias',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '373',
      likeCount: '53',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/PKy1sWIc0i0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'BAeN8pRnBnmfMv199B077G1A-F4',
    id: 'MkPI1cnLNT0',
    snippet: {
      publishedAt: '2023-07-22T02:38:30Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bombom de cereja ao licor',
      description:
        '🍒 Aqui está o melhor e mais fácil bombom de cereja ao licor 🥃 \n\n🍒 Vamos a receita? \n\n🍒Creme licoroso \n200g de açúcar de confeiteiro impalpável \n50ml de licor de cerejas \n\n🍒Misture bem e coloque em saquinho ou manga de confeitar. \n\n🍒Trufa \n200g de chocolate meio amargo derretido \n200g de creme de leite \n\n🍒Misture bem e coloque em saquinho ou manga de confeitar. \n\n🍒Derreta 250g de chocolate meio amargo e coloque em saquinho ou manga de confeitar. \n\n🍒Reserve 20 cerejas ao licor (não precisa escorrer) \n\n🍒Escolha uma forma de bombons e coloque até a metade de cada cavidade cobertura premium meio amarga, injete um pouco de creme licoroso, coloque uma cereja, injete um pouco da trufa e feche com chocolate. Leve para secar na geladeira até a forma ficar transparente. Desenforme e pronto! \n\n🍒Validade 90 dias sem Refrigeracao. \n🍒Rendimento 20 bombons de 50g',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/MkPI1cnLNT0/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/MkPI1cnLNT0/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/MkPI1cnLNT0/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/MkPI1cnLNT0/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/MkPI1cnLNT0/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bombom de cereja ao licor',
        description:
          '🍒 Aqui está o melhor e mais fácil bombom de cereja ao licor 🥃 \n\n🍒 Vamos a receita? \n\n🍒Creme licoroso \n200g de açúcar de confeiteiro impalpável \n50ml de licor de cerejas \n\n🍒Misture bem e coloque em saquinho ou manga de confeitar. \n\n🍒Trufa \n200g de chocolate meio amargo derretido \n200g de creme de leite \n\n🍒Misture bem e coloque em saquinho ou manga de confeitar. \n\n🍒Derreta 250g de chocolate meio amargo e coloque em saquinho ou manga de confeitar. \n\n🍒Reserve 20 cerejas ao licor (não precisa escorrer) \n\n🍒Escolha uma forma de bombons e coloque até a metade de cada cavidade cobertura premium meio amarga, injete um pouco de creme licoroso, coloque uma cereja, injete um pouco da trufa e feche com chocolate. Leve para secar na geladeira até a forma ficar transparente. Desenforme e pronto! \n\n🍒Validade 90 dias sem Refrigeracao. \n🍒Rendimento 20 bombons de 50g',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT2M30S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '763',
      likeCount: '99',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '0',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/MkPI1cnLNT0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'XKQikvSS7hl4xFabd2lTXOX8UAY',
    id: 'DPl-au8hepw',
    snippet: {
      publishedAt: '2023-07-15T00:30:08Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo de frutas sem farinha!',
      description:
        '🥰Essa receita é especial para você que pediu um bolo de frutas, mais saudável e sem farinha branca ❤️\n\n❤️Já salva esse post, compartilhe com as pessoas que vc sabe que amam um bolo quentinho e não esqueça de comentar se gostou dessa receita, tá?! \n\n\nIngredientes \n❤️3 ovos \n❤️2 colheres sopa de manteiga \n❤️4 bananas bem maduras e amassadinhas (usei a nanica) \n❤️1/2 xícara chá de açúcar mascavo \n❤️3 maçãs pequenas cortadas em cubos \n❤️1 colher sopa de canela em pó \n❤️1 xícara chá de uvas passas (usei a branca e a pretinha) \n❤️1 xícara chá de nozes picadas (pode usar amêndoas ou outra castanha se preferir) \n❤️1 colher sopa de fermento em pó \n❤️2 xícaras chá de farelo de aveia ou farinha de aveia',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/DPl-au8hepw/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/DPl-au8hepw/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/DPl-au8hepw/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/DPl-au8hepw/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/DPl-au8hepw/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo de frutas sem farinha!',
        description:
          '🥰Essa receita é especial para você que pediu um bolo de frutas, mais saudável e sem farinha branca ❤️\n\n❤️Já salva esse post, compartilhe com as pessoas que vc sabe que amam um bolo quentinho e não esqueça de comentar se gostou dessa receita, tá?! \n\n\nIngredientes \n❤️3 ovos \n❤️2 colheres sopa de manteiga \n❤️4 bananas bem maduras e amassadinhas (usei a nanica) \n❤️1/2 xícara chá de açúcar mascavo \n❤️3 maçãs pequenas cortadas em cubos \n❤️1 colher sopa de canela em pó \n❤️1 xícara chá de uvas passas (usei a branca e a pretinha) \n❤️1 xícara chá de nozes picadas (pode usar amêndoas ou outra castanha se preferir) \n❤️1 colher sopa de fermento em pó \n❤️2 xícaras chá de farelo de aveia ou farinha de aveia',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT4M14S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '784',
      likeCount: '103',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/DPl-au8hepw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'finGt0PfmTA-1he6kW_PBza1IX8',
    id: 'FJSZoyHysrU',
    snippet: {
      publishedAt: '2023-07-06T02:15:07Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pé de moleque cremoso ou pé de moça',
      description:
        '✅200g de açúcar \n✅20g de manteiga ou margarina \n✅395g de leite condensado \n✅300g de amendoim torrado, sem pele e sem sal\n✅Desmoldante para untar a forma e não grudar nadinha 😉',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/FJSZoyHysrU/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/FJSZoyHysrU/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/FJSZoyHysrU/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/FJSZoyHysrU/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/FJSZoyHysrU/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pé de moleque cremoso ou pé de moça',
        description:
          '✅200g de açúcar \n✅20g de manteiga ou margarina \n✅395g de leite condensado \n✅300g de amendoim torrado, sem pele e sem sal\n✅Desmoldante para untar a forma e não grudar nadinha 😉',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M55S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '721',
      likeCount: '107',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '2',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/FJSZoyHysrU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'FPWaNnrgj2wqwCKSA3qwLVTKAe0',
    id: 'KvDFewRIqYI',
    snippet: {
      publishedAt: '2023-07-01T03:00:11Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Amendoim doce de microondas',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/KvDFewRIqYI/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/KvDFewRIqYI/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/KvDFewRIqYI/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/KvDFewRIqYI/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/KvDFewRIqYI/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Amendoim doce de microondas',
        description: '',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT55S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '3748',
      likeCount: '335',
      dislikeCount: '15',
      favoriteCount: '0',
      commentCount: '6',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/KvDFewRIqYI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '4x3N1lcfSfAltgIGKIX4JsLvvwg',
    id: 'El6363fQYII',
    snippet: {
      publishedAt: '2023-07-01T01:08:20Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'arroz doce caramelizado',
      description:
        '🔥Arroz doce caramelizado \n\nSe eu fosse vc, faria essa receita ainda hoje❤️\n\n🔥Salva para não perder, hein?! \n\n🔥1 xícara de chá de arroz\n🔥2 xícaras de chá de água \n🔥Canela e cravo para temperar \n🔥Gotas de aroma de baunilha branca\n🔥1 xícara chá de açúcar \n🔥480ml de leite \n🔥50g de recheio creme confeiteiro Mavalério \n🔥1 xícara chá de amendoim torrado sem pele e sem sal.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/El6363fQYII/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/El6363fQYII/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/El6363fQYII/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/El6363fQYII/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/El6363fQYII/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'arroz doce caramelizado',
        description:
          '🔥Arroz doce caramelizado \n\nSe eu fosse vc, faria essa receita ainda hoje❤️\n\n🔥Salva para não perder, hein?! \n\n🔥1 xícara de chá de arroz\n🔥2 xícaras de chá de água \n🔥Canela e cravo para temperar \n🔥Gotas de aroma de baunilha branca\n🔥1 xícara chá de açúcar \n🔥480ml de leite \n🔥50g de recheio creme confeiteiro Mavalério \n🔥1 xícara chá de amendoim torrado sem pele e sem sal.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT2M34S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '624',
      likeCount: '83',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '6',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/El6363fQYII" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '47mzMisvJGDpyd45EOS7UP3etP8',
    id: 'SP7zEK6el6g',
    snippet: {
      publishedAt: '2023-06-09T13:45:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo na marmita feito com biscoito Oreo',
      description:
        '❤️Você não pode deixar de fazer esse bolo!!! \n\n\n❤️Fica realmente delicioso e é um ótimo faça e venda!!!! 💰\n\n\n☀️Salva esse post e printa a listinha de tudo que precisa comprar na Funchal tá?! Aliás, nem precisa sair de casa pq a Funchal entrega rapidinho pra vc! \n\n\n❤️Receitinha: \n20 biscoitos Oreo (2 pacotes) \n240ml de leite \n5g de fermento em pó \n\n\n❤️Ganache \n100g de chocolate derretido \n100g de creme de leite \n\n\n❤️Listinha de compras \n✅Biscoito oreo \n✅Leite \n✅Fermento em pó \n✅Marmitinha descartável com tampa usei a medida 15x10cm \n✅Desmoldante Liviss \n✅Creme de leite \n✅Chocolate meio amargo',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/SP7zEK6el6g/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/SP7zEK6el6g/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/SP7zEK6el6g/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/SP7zEK6el6g/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/SP7zEK6el6g/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo na marmita feito com biscoito Oreo',
        description:
          '❤️Você não pode deixar de fazer esse bolo!!! \n\n\n❤️Fica realmente delicioso e é um ótimo faça e venda!!!! 💰\n\n\n☀️Salva esse post e printa a listinha de tudo que precisa comprar na Funchal tá?! Aliás, nem precisa sair de casa pq a Funchal entrega rapidinho pra vc! \n\n\n❤️Receitinha: \n20 biscoitos Oreo (2 pacotes) \n240ml de leite \n5g de fermento em pó \n\n\n❤️Ganache \n100g de chocolate derretido \n100g de creme de leite \n\n\n❤️Listinha de compras \n✅Biscoito oreo \n✅Leite \n✅Fermento em pó \n✅Marmitinha descartável com tampa usei a medida 15x10cm \n✅Desmoldante Liviss \n✅Creme de leite \n✅Chocolate meio amargo',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M43S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '580',
      likeCount: '92',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '5',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/SP7zEK6el6g" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'KPLK2jB-i5JCXi_Rgqrmtg1pfrQ',
    id: 'dxzn6b7wccY',
    snippet: {
      publishedAt: '2023-06-08T13:45:08Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pipoca doce com dois ingredientes',
      description:
        '🍿 Essa receita de Pipoca colorida é para fazer brincando de tão fácil que é ! \n\nJá salva esse post para eternizar ❤️\n\n🍿500g de açúcar colorido Mavalério (usei o vermelho) \n🍿5 xícaras de pipocas já estouradas sem sal \n\n✅Validade é de 10 dias bem fechada em saquinhos.\n💡Se deixar aberto, além de murcha, pode derreter o açúcar.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/dxzn6b7wccY/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/dxzn6b7wccY/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/dxzn6b7wccY/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/dxzn6b7wccY/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/dxzn6b7wccY/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pipoca doce com dois ingredientes',
        description:
          '🍿 Essa receita de Pipoca colorida é para fazer brincando de tão fácil que é ! \n\nJá salva esse post para eternizar ❤️\n\n🍿500g de açúcar colorido Mavalério (usei o vermelho) \n🍿5 xícaras de pipocas já estouradas sem sal \n\n✅Validade é de 10 dias bem fechada em saquinhos.\n💡Se deixar aberto, além de murcha, pode derreter o açúcar.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT52S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '1038',
      likeCount: '122',
      dislikeCount: '3',
      favoriteCount: '0',
      commentCount: '0',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/dxzn6b7wccY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'RzxrZgCrFHGZ3i6wS1YpZ9mNB58',
    id: 'yZo_YIbpcqo',
    snippet: {
      publishedAt: '2023-06-07T13:45:11Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo de milho no microondas em 5 minutos',
      description:
        '🌽Sabe aquele bolo com gostinho de pamonha?!\n\n🌽Achou!!!!!! \n\n🌽Essa receita é uma das melhores, acredite pq é baum demais, sô!!!\n\n🌽Eu fiz no microondas 5 minutos potência alta mas, se preferir pode assar no forno convencional a 180graus aproximadamente 25 a 30 minutos. \n\n🌽100ml de óleo \n🌽240ml de leite \n🌽2 ovos \n🌽1 lata de milho verde \n🌽1/2 xícara chá de farinha de milho fina \n🌽1 xícara chá de farinha de trigo\n🌽1 colher sopa de fermento em pó \n\n✅Forma retangular 25 x 15 cm \n✅Desmoldante Liviss para untar a forma.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/yZo_YIbpcqo/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/yZo_YIbpcqo/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/yZo_YIbpcqo/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/yZo_YIbpcqo/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/yZo_YIbpcqo/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo de milho no microondas em 5 minutos',
        description:
          '🌽Sabe aquele bolo com gostinho de pamonha?!\n\n🌽Achou!!!!!! \n\n🌽Essa receita é uma das melhores, acredite pq é baum demais, sô!!!\n\n🌽Eu fiz no microondas 5 minutos potência alta mas, se preferir pode assar no forno convencional a 180graus aproximadamente 25 a 30 minutos. \n\n🌽100ml de óleo \n🌽240ml de leite \n🌽2 ovos \n🌽1 lata de milho verde \n🌽1/2 xícara chá de farinha de milho fina \n🌽1 xícara chá de farinha de trigo\n🌽1 colher sopa de fermento em pó \n\n✅Forma retangular 25 x 15 cm \n✅Desmoldante Liviss para untar a forma.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '3395',
      likeCount: '194',
      dislikeCount: '5',
      favoriteCount: '0',
      commentCount: '10',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/yZo_YIbpcqo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'k6CEM-iaTltRl1MmPiBSZtvssec',
    id: 'GqcIHEQcDA8',
    snippet: {
      publishedAt: '2023-05-14T15:32:52Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Arroz de forno cremoso',
      description:
        'Ingredientes da receita:\n4 xicaras (cha) de arroz cozido a gosto\n1 colher (sopa) de azeite\n1 colher (sopa) de manteiga\n1 cebola media picada\n1 colher (sopa) de alho picado\n400g de frango cozido e desfiado\n1 colher (sopa) de páprica doce defumada\n1 lata de ervilhas\n2 xicaras (cha) de molho de tomate de sua preferencia\n1 xicara (cha) de azeitonas em rodelas\n400g de mussarela para ralar\n! colher (Cha) de Tempero completo com Pimenta OLIVEIRA\n \nEm uma panela grande coloque o azeite com a manteiga até derreter e comece a refogar o alho e a cebola. Em seguida acrescente o frango desfiado, a páprica, as ervilhas, azeitonas o molho de tomate e por ultimo 1/3 da mussarela ralada. Mexa bem e retire do fogo. Prepare o creme de milho e reserve.\nEm um refratário grande intercale camadas de arroz, creme de milho, mussarela ralada e refogado de frango. Repita o processo mais uma vez e finalize com mussarela ralada. Leve ao forno alto para gratinar e sirva em seguida.\n \nCreme de milho\n2 latas de milho cozido\n1 colher (sopa) de manteiga\n1 lata de creme de leite com soro\n240ml de leite\n250g de queijo cremoso (catupiry)\n! colher (Cha) de Tempero completo com Pimenta OLIVEIRA\n \nModo de preparo:\nBata o milho no liquidificador com o creme de leite, o leite e a manteiga ate ficar completamente liso. Leve ao fogo com o requeijão cremoso ate engrossar. Corrija o sal e acrescente pimenta se desejar.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/GqcIHEQcDA8/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/GqcIHEQcDA8/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/GqcIHEQcDA8/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/GqcIHEQcDA8/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/GqcIHEQcDA8/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Arroz de forno cremoso',
        description:
          'Ingredientes da receita:\n4 xicaras (cha) de arroz cozido a gosto\n1 colher (sopa) de azeite\n1 colher (sopa) de manteiga\n1 cebola media picada\n1 colher (sopa) de alho picado\n400g de frango cozido e desfiado\n1 colher (sopa) de páprica doce defumada\n1 lata de ervilhas\n2 xicaras (cha) de molho de tomate de sua preferencia\n1 xicara (cha) de azeitonas em rodelas\n400g de mussarela para ralar\n! colher (Cha) de Tempero completo com Pimenta OLIVEIRA\n \nEm uma panela grande coloque o azeite com a manteiga até derreter e comece a refogar o alho e a cebola. Em seguida acrescente o frango desfiado, a páprica, as ervilhas, azeitonas o molho de tomate e por ultimo 1/3 da mussarela ralada. Mexa bem e retire do fogo. Prepare o creme de milho e reserve.\nEm um refratário grande intercale camadas de arroz, creme de milho, mussarela ralada e refogado de frango. Repita o processo mais uma vez e finalize com mussarela ralada. Leve ao forno alto para gratinar e sirva em seguida.\n \nCreme de milho\n2 latas de milho cozido\n1 colher (sopa) de manteiga\n1 lata de creme de leite com soro\n240ml de leite\n250g de queijo cremoso (catupiry)\n! colher (Cha) de Tempero completo com Pimenta OLIVEIRA\n \nModo de preparo:\nBata o milho no liquidificador com o creme de leite, o leite e a manteiga ate ficar completamente liso. Leve ao fogo com o requeijão cremoso ate engrossar. Corrija o sal e acrescente pimenta se desejar.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT2M47S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '613',
      likeCount: '101',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/GqcIHEQcDA8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'AdljucHFrqVK6A9oxEcG6a0r41k',
    id: 'XhBwJmBDVtU',
    snippet: {
      publishedAt: '2023-04-10T03:00:11Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Cookies de microondas para fazer agora ❤️',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/XhBwJmBDVtU/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/XhBwJmBDVtU/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/XhBwJmBDVtU/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/XhBwJmBDVtU/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/XhBwJmBDVtU/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Cookies de microondas para fazer agora ❤️',
        description: '',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT2M19S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '484',
      likeCount: '73',
      dislikeCount: '1',
      favoriteCount: '0',
      commentCount: '2',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/XhBwJmBDVtU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'RKXnSMsY_Q11DxyTn0ris0Ad2-Y',
    id: 'lKG3cjK3xmI',
    snippet: {
      publishedAt: '2023-04-09T17:21:52Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Morango encapado a famosa coxinha de morango 🍓',
      description: 'Coxinha de morango 🍓',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/lKG3cjK3xmI/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/lKG3cjK3xmI/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/lKG3cjK3xmI/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/lKG3cjK3xmI/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/lKG3cjK3xmI/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Morango encapado a famosa coxinha de morango 🍓',
        description: 'Coxinha de morango 🍓',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT5M25S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '896',
      likeCount: '115',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '5',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/lKG3cjK3xmI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '2ri1wwEY81g3inaHc0kdQC6TQkE',
    id: 'STfrvcPPNgo',
    snippet: {
      publishedAt: '2023-02-28T15:53:49Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Prepare cascas de ovos com antecedência de maneira super prática!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/STfrvcPPNgo/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/STfrvcPPNgo/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/STfrvcPPNgo/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/STfrvcPPNgo/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/STfrvcPPNgo/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Prepare cascas de ovos com antecedência de maneira super prática!',
        description: '',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT58S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '2580',
      likeCount: '193',
      dislikeCount: '9',
      favoriteCount: '0',
      commentCount: '1',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/STfrvcPPNgo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'VVLC6y3rDyhmgMjB6jeljJ4FUjs',
    id: 'P01eorVXEro',
    snippet: {
      publishedAt: '2023-01-30T23:00:09Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Fature alto com essa receita de geladinho gourmet',
      description:
        'Geladinho Gourmet, além de delicioso e refrescante, é muito fácil e vc precisa de pouquíssimos ingredientes. \n\n✅Para formar a casquinha vc vai precisar de:\n\n🧊250g de cobertura premium blend \n🧊saquinhos para geladinho ou sacolé \n\n🧊Creme de morango 🍓 \n500ml de leite \n395g de leite condensado \n15g de liga neutra \n30g de pó para preparo de sobremesa sabor morango\n\n💡Essa receita rende em torno de 20 unidades;\n💡Validade 60 dias congelado',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/P01eorVXEro/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/P01eorVXEro/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/P01eorVXEro/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/P01eorVXEro/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/P01eorVXEro/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Fature alto com essa receita de geladinho gourmet',
        description:
          'Geladinho Gourmet, além de delicioso e refrescante, é muito fácil e vc precisa de pouquíssimos ingredientes. \n\n✅Para formar a casquinha vc vai precisar de:\n\n🧊250g de cobertura premium blend \n🧊saquinhos para geladinho ou sacolé \n\n🧊Creme de morango 🍓 \n500ml de leite \n395g de leite condensado \n15g de liga neutra \n30g de pó para preparo de sobremesa sabor morango\n\n💡Essa receita rende em torno de 20 unidades;\n💡Validade 60 dias congelado',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M35S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '851',
      likeCount: '107',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '2',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/P01eorVXEro" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'XJLBr_UXNNtW1g-SCSaDYU4FSZs',
    id: 'BR8_KAU-KWc',
    snippet: {
      publishedAt: '2023-01-30T01:44:26Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Cobertura perfeita  para bolos  super econômica com poucos ingredientes!',
      description:
        'Essa receita foi feita para você que precisa de uma cobertura prática, econômica e deliciosa para usar em\nvários tipos de bolos! \n\nNão precisa de batedeira mas se quiser triplicar a receita, pode usar!!!!\n\nAnota os ingredientes 😉\n\n❤️500g de açúcar de confeiteiro impalpável  \n❤️100g de chocolate em pó 50% cacau \n❤️50g de manteiga ou margarina em temperatura ambiente \n❤️ gotas de aroma de baunilha branca\n❤️120ml de leite ou água (coloque aos poucos, pode ser que use um pouco menos)',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/BR8_KAU-KWc/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/BR8_KAU-KWc/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/BR8_KAU-KWc/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/BR8_KAU-KWc/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/BR8_KAU-KWc/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Cobertura perfeita  para bolos  super econômica com poucos ingredientes!',
        description:
          'Essa receita foi feita para você que precisa de uma cobertura prática, econômica e deliciosa para usar em\nvários tipos de bolos! \n\nNão precisa de batedeira mas se quiser triplicar a receita, pode usar!!!!\n\nAnota os ingredientes 😉\n\n❤️500g de açúcar de confeiteiro impalpável  \n❤️100g de chocolate em pó 50% cacau \n❤️50g de manteiga ou margarina em temperatura ambiente \n❤️ gotas de aroma de baunilha branca\n❤️120ml de leite ou água (coloque aos poucos, pode ser que use um pouco menos)',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT41S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '3391',
      likeCount: '217',
      dislikeCount: '10',
      favoriteCount: '0',
      commentCount: '0',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/BR8_KAU-KWc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'u1s_1N2q0DQ4bHAYW6ETnKyHqFc',
    id: 'HsTK9jxOY8I',
    snippet: {
      publishedAt: '2023-01-25T22:00:08Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Sobrou panetone? Faça essa sobremesa !!',
      description:
        '🍫Tem panetone sobrando em casa??? \n\n🍫Então bora transformar em mini delícias?! \n\n🍫Vc precisará de:\n\n🍫Panetone cortado em cubos \n🍫300g de Cobertura Premium Mavalério (usei a amarga) \n🍫Confeitos Mavalério para decorar',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/HsTK9jxOY8I/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/HsTK9jxOY8I/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/HsTK9jxOY8I/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/HsTK9jxOY8I/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/HsTK9jxOY8I/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Sobrou panetone? Faça essa sobremesa !!',
        description:
          '🍫Tem panetone sobrando em casa??? \n\n🍫Então bora transformar em mini delícias?! \n\n🍫Vc precisará de:\n\n🍫Panetone cortado em cubos \n🍫300g de Cobertura Premium Mavalério (usei a amarga) \n🍫Confeitos Mavalério para decorar',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT49S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '2536',
      likeCount: '162',
      dislikeCount: '6',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/HsTK9jxOY8I" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'nhDRw25mtysb9sIH6SV8I10RgMg',
    id: 'wFuQWdLhQ00',
    snippet: {
      publishedAt: '2023-01-24T12:57:30Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Sobremesa simples mas com cara de rica 🤩',
      description:
        '🍓Sobremesa fácil para vc fazer agora! \n\n\n🍓Corte fatias de massa de bolo \nRed Velvet Mavalério (prepare conforme instruções da embalagem)\n\n🍓Recheio 1 \n395g de leite condensado \n15g de Pó para preparo de sobremesa sabor morango Mavalério \n\n🍓Recheio 2 \n300ml de Chantily bem gelado\n15g de saborizante para Chantily sabor Morango Mavalério',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/wFuQWdLhQ00/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/wFuQWdLhQ00/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/wFuQWdLhQ00/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/wFuQWdLhQ00/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/wFuQWdLhQ00/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Sobremesa simples mas com cara de rica 🤩',
        description:
          '🍓Sobremesa fácil para vc fazer agora! \n\n\n🍓Corte fatias de massa de bolo \nRed Velvet Mavalério (prepare conforme instruções da embalagem)\n\n🍓Recheio 1 \n395g de leite condensado \n15g de Pó para preparo de sobremesa sabor morango Mavalério \n\n🍓Recheio 2 \n300ml de Chantily bem gelado\n15g de saborizante para Chantily sabor Morango Mavalério',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT57S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '3356',
      likeCount: '233',
      dislikeCount: '7',
      favoriteCount: '0',
      commentCount: '2',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/wFuQWdLhQ00" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'pFsFa9hMOuIlw5j2ORQfPHcOJBo',
    id: 'r5b_iAShQcY',
    snippet: {
      publishedAt: '2022-12-31T15:48:24Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Receita de Bolo de Sorvete fácil de fazer!',
      description:
        'Essa é a receita mais fácil e gostosa que vc ja viu! \n\n🍦Massa do bolo \n2 ovos\n50ml de óleo \n100ml de água \n80g de Açúcar \n20g de cacau em pó \n180g de farinha de trigo \n10g de fermento em pó \n\n🍦Misture tudo muito bem, unte uma forma de 20cm com Desmoldante Liviss e leve para assar no microondas potência alta por 4 minutos. \n\n🍦Recheio \n1 litro de sorvete de sua preferência (usei sabor Creme) Ah, o sorvete precisa estar congelado, tá? \n\n🍦Para cobrir usei uma Ganache \n100g de chocolate ao leite\n100ml de creme de leite \n\n🍦Derreta o chocolate e misture o creme de leite. \n\n🍦Para acabamento usei Doce de leite na manga de confeitar com bico pitanga 1M',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/r5b_iAShQcY/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/r5b_iAShQcY/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/r5b_iAShQcY/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/r5b_iAShQcY/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/r5b_iAShQcY/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Receita de Bolo de Sorvete fácil de fazer!',
        description:
          'Essa é a receita mais fácil e gostosa que vc ja viu! \n\n🍦Massa do bolo \n2 ovos\n50ml de óleo \n100ml de água \n80g de Açúcar \n20g de cacau em pó \n180g de farinha de trigo \n10g de fermento em pó \n\n🍦Misture tudo muito bem, unte uma forma de 20cm com Desmoldante Liviss e leve para assar no microondas potência alta por 4 minutos. \n\n🍦Recheio \n1 litro de sorvete de sua preferência (usei sabor Creme) Ah, o sorvete precisa estar congelado, tá? \n\n🍦Para cobrir usei uma Ganache \n100g de chocolate ao leite\n100ml de creme de leite \n\n🍦Derreta o chocolate e misture o creme de leite. \n\n🍦Para acabamento usei Doce de leite na manga de confeitar com bico pitanga 1M',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT59S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '4218',
      likeCount: '274',
      dislikeCount: '9',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/r5b_iAShQcY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'EDCtWVbmfyNBeP0v4LRsm650kTE',
    id: 'nQR42O_PYzs',
    snippet: {
      publishedAt: '2022-12-31T14:25:44Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Receita de Bolo de sorvete fácil de fazer',
      description:
        'Essa é a receita mais fácil e gostosa que vc ja viu! \n\n🍦Massa do bolo \n2 ovos\n50ml de óleo \n100ml de água \n80g de Açúcar \n20g de cacau em pó \n180g de farinha de trigo \n10g de fermento em pó \n\n🍦Misture tudo muito bem, unte uma forma de 20cm com Desmoldante Liviss e leve para assar no microondas potência alta por 4 minutos. \n\n🍦Recheio \n1 litro de sorvete de sua preferência (usei sabor Creme) Ah, o sorvete precisa estar congelado, tá? \n\n🍦Para cobrir usei uma Ganache \n100g de chocolate ao leite\n100ml de creme de leite \n\n🍦Derreta o chocolate e misture o creme de leite. \n\n🍦Para acabamento usei Doce de leite na manga de confeitar com bico pitanga 1M',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/nQR42O_PYzs/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/nQR42O_PYzs/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/nQR42O_PYzs/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/nQR42O_PYzs/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/nQR42O_PYzs/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Receita de Bolo de sorvete fácil de fazer',
        description:
          'Essa é a receita mais fácil e gostosa que vc ja viu! \n\n🍦Massa do bolo \n2 ovos\n50ml de óleo \n100ml de água \n80g de Açúcar \n20g de cacau em pó \n180g de farinha de trigo \n10g de fermento em pó \n\n🍦Misture tudo muito bem, unte uma forma de 20cm com Desmoldante Liviss e leve para assar no microondas potência alta por 4 minutos. \n\n🍦Recheio \n1 litro de sorvete de sua preferência (usei sabor Creme) Ah, o sorvete precisa estar congelado, tá? \n\n🍦Para cobrir usei uma Ganache \n100g de chocolate ao leite\n100ml de creme de leite \n\n🍦Derreta o chocolate e misture o creme de leite. \n\n🍦Para acabamento usei Doce de leite na manga de confeitar com bico pitanga 1M',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT59S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '2302',
      likeCount: '159',
      dislikeCount: '9',
      favoriteCount: '0',
      commentCount: '3',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/nQR42O_PYzs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'oyAGdjMfjGEYFK0CMuFmRbqF9Z0',
    id: 'sq5e3aMOx0Y',
    snippet: {
      publishedAt: '2022-12-24T20:58:57Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Melhor jeito de preparar Peru para ceia !',
      description:
        'Tem dúvida de como preparar a ave natalina?! \n\n❤️Vou te mostrar como eu faço para minha família ❤️\n\n🎄Primeiro passo é temperar! \nQuanto mais tempo ficar Marinando na geladeira, melhor! \n\n🎄“Para temperar”\n🎄1/2 maço de salsinha \n🎄1/2 xícara chá de azeite \n🎄Sal a gosto \n🎄1 cebola bem grande sem pele \n🎄1/2 xícara chá de mostarda \n🎄1/2 xícara chá de mel (tem na Funchal)\n🎄240ml de vinho branco (tem na Funchal) \n\n🎄Bata tudo no liquidificador! \n\n🎄Acompanhe o passo a passo no vídeo.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/sq5e3aMOx0Y/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/sq5e3aMOx0Y/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/sq5e3aMOx0Y/hqdefault.jpg',
          width: 480,
          height: 360,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Melhor jeito de preparar Peru para ceia !',
        description:
          'Tem dúvida de como preparar a ave natalina?! \n\n❤️Vou te mostrar como eu faço para minha família ❤️\n\n🎄Primeiro passo é temperar! \nQuanto mais tempo ficar Marinando na geladeira, melhor! \n\n🎄“Para temperar”\n🎄1/2 maço de salsinha \n🎄1/2 xícara chá de azeite \n🎄Sal a gosto \n🎄1 cebola bem grande sem pele \n🎄1/2 xícara chá de mostarda \n🎄1/2 xícara chá de mel (tem na Funchal)\n🎄240ml de vinho branco (tem na Funchal) \n\n🎄Bata tudo no liquidificador! \n\n🎄Acompanhe o passo a passo no vídeo.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT2M31S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '346',
      likeCount: '30',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '0',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/sq5e3aMOx0Y" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'b2mWNRrF-1lHKsQYuQsRfJI_iaY',
    id: 'leaY8P8LMmU',
    snippet: {
      publishedAt: '2022-12-02T12:45:02Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pâo de Mel Divino, SUPER aula completa para quem precisa de uma renda extra.',
      description:
        'Estou disponibilizando essa aula completíssima do meu curso de presente para você. \n\nCostumo dizer que essa receita é um norte para quem precisa de uma renda extra.\n\nEspero de coração que este video seja muito útil para você! \n\nCompartilhe esse video com o máximo de pessoas que puder! Com a sua ajuda, chegará nas mãos de milhares de pessoas!\n\nMassa Pão de mel\n\nIngredientes\n\n120 g de mel ou similar\n\n45 g de chocolate em pó 50% ou 70%\n\n75 g de açúcar mascavo\n\n50 g de ovo\n\n250 ml de leite\n\n50 g de óleo\n\n240 g de farinha de trigo\n\n5 g de bicarbonato de sódio\n\n5 g de canela em pó\n\n2 g de cravo em pó\n\n5 g de fermento em pó\n\nModo de preparo\n\nAcompanhe o passo a passo detalhado no vídeo!\n\nPara o banho e decoração\n\nIngredientes\n\n½ kg de cobertura fracionada sabor chocolate ao leite (ou sabor de sua preferência)\n\nCoco seco ralado Q.B. (quanto baste) – para decoração\n\nSubstituições:\n\nO chocolate em pó pode ser substituído por cacau em pó. Caso opte pelo cacau em pó, empregue apenas 50% da quantidade descrita acima\nPara o pão de mel na cor tradicional, retire o chocolate em pó da receita.\nEm substituição ao mel, usar alimento glicosado, como favinho ou mel de jataí. Não usar como substituição do mel glucose ou glucose de milho.\nA forma individual utilizada foi a nº 2 (ela tem 4 a 4,5 cm de diâmetro x 1,5 a 2 cm de altura)\nDica\n\n\nno forno convencional: 25 minutos a 180º C\n\nno micro-ondas: para formas individuais, o tempo aproximado é de 2 minutos, potência alta / em assadeira, de 5 a 7 minutos, em potência alta.\n\nRecheio tipo prestígio\n\nIngredientes\n\n200 g de leite condensado\n\n100 g de coro ralado seco\n\nModo de preparo\n\nAcompanhe o passo a passo detalhado no vídeo!\n\nRendimento do pão de mel no forno (forma individual): cerca de 12 unidades\n\nRendimento do pão de mel no micro-ondas (forma individual): cerca de 18 unidades\n\nValidades:\n\nRecheio “tipo prestígio” com coco seco desidratado: 5 dias\n\nRecheio “tipo prestígio” com coco fresco: 3 dias\n\nRecheio doce de leite: 10 dias\n\nRecheio brigadeiro: 10 dias',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/leaY8P8LMmU/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/leaY8P8LMmU/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/leaY8P8LMmU/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/leaY8P8LMmU/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/leaY8P8LMmU/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pâo de Mel Divino, SUPER aula completa para quem precisa de uma renda extra.',
        description:
          'Estou disponibilizando essa aula completíssima do meu curso de presente para você. \n\nCostumo dizer que essa receita é um norte para quem precisa de uma renda extra.\n\nEspero de coração que este video seja muito útil para você! \n\nCompartilhe esse video com o máximo de pessoas que puder! Com a sua ajuda, chegará nas mãos de milhares de pessoas!\n\nMassa Pão de mel\n\nIngredientes\n\n120 g de mel ou similar\n\n45 g de chocolate em pó 50% ou 70%\n\n75 g de açúcar mascavo\n\n50 g de ovo\n\n250 ml de leite\n\n50 g de óleo\n\n240 g de farinha de trigo\n\n5 g de bicarbonato de sódio\n\n5 g de canela em pó\n\n2 g de cravo em pó\n\n5 g de fermento em pó\n\nModo de preparo\n\nAcompanhe o passo a passo detalhado no vídeo!\n\nPara o banho e decoração\n\nIngredientes\n\n½ kg de cobertura fracionada sabor chocolate ao leite (ou sabor de sua preferência)\n\nCoco seco ralado Q.B. (quanto baste) – para decoração\n\nSubstituições:\n\nO chocolate em pó pode ser substituído por cacau em pó. Caso opte pelo cacau em pó, empregue apenas 50% da quantidade descrita acima\nPara o pão de mel na cor tradicional, retire o chocolate em pó da receita.\nEm substituição ao mel, usar alimento glicosado, como favinho ou mel de jataí. Não usar como substituição do mel glucose ou glucose de milho.\nA forma individual utilizada foi a nº 2 (ela tem 4 a 4,5 cm de diâmetro x 1,5 a 2 cm de altura)\nDica\n\n\nno forno convencional: 25 minutos a 180º C\n\nno micro-ondas: para formas individuais, o tempo aproximado é de 2 minutos, potência alta / em assadeira, de 5 a 7 minutos, em potência alta.\n\nRecheio tipo prestígio\n\nIngredientes\n\n200 g de leite condensado\n\n100 g de coro ralado seco\n\nModo de preparo\n\nAcompanhe o passo a passo detalhado no vídeo!\n\nRendimento do pão de mel no forno (forma individual): cerca de 12 unidades\n\nRendimento do pão de mel no micro-ondas (forma individual): cerca de 18 unidades\n\nValidades:\n\nRecheio “tipo prestígio” com coco seco desidratado: 5 dias\n\nRecheio “tipo prestígio” com coco fresco: 3 dias\n\nRecheio doce de leite: 10 dias\n\nRecheio brigadeiro: 10 dias',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT44M27S',
      dimension: '2d',
      definition: 'sd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
      selfDeclaredMadeForKids: false,
    },
    statistics: {
      viewCount: '1592',
      likeCount: '215',
      dislikeCount: '1',
      favoriteCount: '0',
      commentCount: '22',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/leaY8P8LMmU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '7y36GlQVxHpGFxrJnho8AQ5fGFs',
    id: '1HcCj2Esi3I',
    snippet: {
      publishedAt: '2022-12-02T00:40:11Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Coquetel sem álcool para torcer durante os jogos 🇧🇷',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/1HcCj2Esi3I/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/1HcCj2Esi3I/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/1HcCj2Esi3I/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/1HcCj2Esi3I/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/1HcCj2Esi3I/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Coquetel sem álcool para torcer durante os jogos 🇧🇷',
        description: '',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT51S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '3035',
      likeCount: '269',
      dislikeCount: '7',
      favoriteCount: '0',
      commentCount: '0',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="360" src="//www.youtube.com/embed/1HcCj2Esi3I" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'GHX4CfhVZp_k_tX9FIip1dQ2AFY',
    id: 'GNY3Spxx9QE',
    snippet: {
      publishedAt: '2022-11-30T22:00:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pao Brasil!!!! a melhor massa que vc ja fez!',
      description:
        '🇧🇷250ml de leite \n🇧🇷100ml de água \n🇧🇷100ml óleo \n🚀10g Fermento biológico seco \n🇧🇷50g de açúcar \n🇧🇷1 pitada de sal \n🇧🇷625g de farinha de trigo aproximadamente \n🇧🇷Corantes em Gel nas cores Verde e amarelo \n🇧🇷Mel ou geleia de brilho para finalizar \n🇧🇷Pincel de silicone \n🇧🇷Forma redonda de silicone',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/GNY3Spxx9QE/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/GNY3Spxx9QE/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/GNY3Spxx9QE/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/GNY3Spxx9QE/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/GNY3Spxx9QE/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pao Brasil!!!! a melhor massa que vc ja fez!',
        description:
          '🇧🇷250ml de leite \n🇧🇷100ml de água \n🇧🇷100ml óleo \n🚀10g Fermento biológico seco \n🇧🇷50g de açúcar \n🇧🇷1 pitada de sal \n🇧🇷625g de farinha de trigo aproximadamente \n🇧🇷Corantes em Gel nas cores Verde e amarelo \n🇧🇷Mel ou geleia de brilho para finalizar \n🇧🇷Pincel de silicone \n🇧🇷Forma redonda de silicone',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT48S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '3276',
      likeCount: '237',
      dislikeCount: '4',
      favoriteCount: '0',
      commentCount: '3',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/GNY3Spxx9QE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'mZeO6qvpKXI_eTjn-Gppz0QJHZQ',
    id: 'sxpvDRaD6JA',
    snippet: {
      publishedAt: '2022-11-30T02:40:25Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pudim pratico',
      description:
        '🇧🇷Olha o GOLLL e olha essa sobremesa para preparar para o próximo jogo!!! \n\n🇧🇷Fácil fácil!!!\n\n🇧🇷400g de creme confeiteiro Mavalério \n🇧🇷500ml de leite (isso mesmo! Vc vai usar a metade do leite indicado na embalagem para obter essa textura de corte incrível) \n🇧🇷Corante verde Wilton \n🇧🇷Forma de silicone para cupcake\n🇧🇷Desmoldante',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/sxpvDRaD6JA/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/sxpvDRaD6JA/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/sxpvDRaD6JA/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/sxpvDRaD6JA/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/sxpvDRaD6JA/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pudim pratico',
        description:
          '🇧🇷Olha o GOLLL e olha essa sobremesa para preparar para o próximo jogo!!! \n\n🇧🇷Fácil fácil!!!\n\n🇧🇷400g de creme confeiteiro Mavalério \n🇧🇷500ml de leite (isso mesmo! Vc vai usar a metade do leite indicado na embalagem para obter essa textura de corte incrível) \n🇧🇷Corante verde Wilton \n🇧🇷Forma de silicone para cupcake\n🇧🇷Desmoldante',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT47S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '18592',
      likeCount: '938',
      dislikeCount: '54',
      favoriteCount: '0',
      commentCount: '5',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/sxpvDRaD6JA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'omD65V10KeT8oxQ9NM40VqHR3XY',
    id: 'THqP6RK0hdc',
    snippet: {
      publishedAt: '2022-11-04T22:00:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Chocolate tipo Chokito caseiro!  Inacreditável, vc precisa fazer!!!!',
      description:
        'Essa é do fundo do baú e entrega nossa idade 😂😂\n\nJá salva e compartilhe com os amigos daquela época! 🙃😉\n\n\n🍫150g de açúcar colorido Mavalério (usei o branco)\n🍫100ml de creme de leite morno\n🍫395g de leite condensado \n🍫 ChocoPower ball mini branco Mavalério \n🍫Cobertura Premium  sabor chocolate meio amargo Mavalério \n\nLeve ao fogo baixo o açúcar até derreter, em seguida acrescente o creme de leite morno misture, acrescente o leite condensado e mexa bem até formar um creme liso. Deixe esfriar e modele passando no ChocoPower. \nFalando nele, misture o que sobrou no prato com Cobertura Premium derretida. Banhe as barrinhas, leve para secar na geladeira e pronto! \n\nEssa receita rende 18 barrinhas e a validade é de 30dias.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/THqP6RK0hdc/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/THqP6RK0hdc/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/THqP6RK0hdc/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/THqP6RK0hdc/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/THqP6RK0hdc/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Chocolate tipo Chokito caseiro!  Inacreditável, vc precisa fazer!!!!',
        description:
          'Essa é do fundo do baú e entrega nossa idade 😂😂\n\nJá salva e compartilhe com os amigos daquela época! 🙃😉\n\n\n🍫150g de açúcar colorido Mavalério (usei o branco)\n🍫100ml de creme de leite morno\n🍫395g de leite condensado \n🍫 ChocoPower ball mini branco Mavalério \n🍫Cobertura Premium  sabor chocolate meio amargo Mavalério \n\nLeve ao fogo baixo o açúcar até derreter, em seguida acrescente o creme de leite morno misture, acrescente o leite condensado e mexa bem até formar um creme liso. Deixe esfriar e modele passando no ChocoPower. \nFalando nele, misture o que sobrou no prato com Cobertura Premium derretida. Banhe as barrinhas, leve para secar na geladeira e pronto! \n\nEssa receita rende 18 barrinhas e a validade é de 30dias.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT57S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '11390',
      likeCount: '951',
      dislikeCount: '16',
      favoriteCount: '0',
      commentCount: '11',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/THqP6RK0hdc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'LV1P8nMuSF6cB4ZHrrtpL2oMvM4',
    id: 'CoooUIJvG-8',
    snippet: {
      publishedAt: '2022-11-04T14:29:14Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo de caneca molhadinho e sem farinha!!!!',
      description:
        '🍫Corre fazer essa receita que é delícia e você merece! \n\n\n🍫50g de cobertura Premium Mavalério (sabor meio amargo) \n🍫1 ovo\n🍫20g de chocolate em pó 50% cacau Mavalério \n🍫3 gotinhas de aroma de baunilha branca Mavalério \n🍫5g de fermento em pó Dr.Oetker \n🍫Cobertura premium sabor chocolate branco Mavalério à gosto \n🍫ChocoPower ball mini Mavalério \n\nEm uma caneca misture os ingredientes e leve ao micro potência alta por 1 minuto e 30 segundos. Retire, cubra com cobertura Premium Mavalério derretida, decore com ChocoPower Ball e é só alegria!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/CoooUIJvG-8/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/CoooUIJvG-8/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/CoooUIJvG-8/hqdefault.jpg',
          width: 480,
          height: 360,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo de caneca molhadinho e sem farinha!!!!',
        description:
          '🍫Corre fazer essa receita que é delícia e você merece! \n\n\n🍫50g de cobertura Premium Mavalério (sabor meio amargo) \n🍫1 ovo\n🍫20g de chocolate em pó 50% cacau Mavalério \n🍫3 gotinhas de aroma de baunilha branca Mavalério \n🍫5g de fermento em pó Dr.Oetker \n🍫Cobertura premium sabor chocolate branco Mavalério à gosto \n🍫ChocoPower ball mini Mavalério \n\nEm uma caneca misture os ingredientes e leve ao micro potência alta por 1 minuto e 30 segundos. Retire, cubra com cobertura Premium Mavalério derretida, decore com ChocoPower Ball e é só alegria!',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT45S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '9331',
      likeCount: '483',
      dislikeCount: '21',
      favoriteCount: '0',
      commentCount: '2',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/CoooUIJvG-8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'J8jUumTMIocgm9FOQ9iZo4jJTbE',
    id: 'wnJGiwoA0A0',
    snippet: {
      publishedAt: '2022-10-26T18:15:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'como fazer A melhor pipoca de chocolate crocante!',
      description:
        '🍿 Pipoca açucarada sabor chocolate\n\n🍿50g de milho para pipoca (premium) \n🍿15ml de óleo \n🍿Leve ao fogo médio até estourar todos os milhos e reserve. \n\n🍿Calda \n🍿100g de açúcar colorido (usei o branco) \n🍿10ml de óleo \n🍿20ml de água \n🍿20g de chocolate em pó 50%cacau \n\n🍿Leve tudo ao fogo médio, qdo abrir bolhas grossas desligue o fogo, mexa e acrescente as pipocas. Mexa bem até encapar todas as pipocas. Embale depois de frio. \n\n🍿Validade 10 dias',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/wnJGiwoA0A0/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/wnJGiwoA0A0/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/wnJGiwoA0A0/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/wnJGiwoA0A0/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/wnJGiwoA0A0/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'como fazer A melhor pipoca de chocolate crocante!',
        description:
          '🍿 Pipoca açucarada sabor chocolate\n\n🍿50g de milho para pipoca (premium) \n🍿15ml de óleo \n🍿Leve ao fogo médio até estourar todos os milhos e reserve. \n\n🍿Calda \n🍿100g de açúcar colorido (usei o branco) \n🍿10ml de óleo \n🍿20ml de água \n🍿20g de chocolate em pó 50%cacau \n\n🍿Leve tudo ao fogo médio, qdo abrir bolhas grossas desligue o fogo, mexa e acrescente as pipocas. Mexa bem até encapar todas as pipocas. Embale depois de frio. \n\n🍿Validade 10 dias',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT41S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '4438',
      likeCount: '422',
      dislikeCount: '10',
      favoriteCount: '0',
      commentCount: '2',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/wnJGiwoA0A0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '4gPI-AyS0thd-38euB-93QRn_fk',
    id: 'qOtPvgbotOw',
    snippet: {
      publishedAt: '2022-10-26T16:00:40Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pirulito de biscoito recheado com brigadeiro que não vai ao fogo!',
      description:
        'Esse pirulito é fácil de fazer e é também um ótimo faça e venda !!!\nDá uma olhadinha !!!!\nFácil, fácil de preparar e com poucos ingredientes vc fará a alegria da criançada ❤️\n\nRecheio de Brigadeiro \n🎈300g de cobertura Premium Mavalério (usei sabor chocolate ao leite) \n🎈20g de chocolate em pó 50% cacau mavalério \n🎈150g de leite condensado \n\nPara montagem \n🎈Palitos e biscoito doce de sua preferência \n\nPara banhar \n🎈Cobertura Premium Mavalério \n🎈Granulado macio Mavalério sabor chocolate',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/qOtPvgbotOw/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/qOtPvgbotOw/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/qOtPvgbotOw/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/qOtPvgbotOw/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/qOtPvgbotOw/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pirulito de biscoito recheado com brigadeiro que não vai ao fogo!',
        description:
          'Esse pirulito é fácil de fazer e é também um ótimo faça e venda !!!\nDá uma olhadinha !!!!\nFácil, fácil de preparar e com poucos ingredientes vc fará a alegria da criançada ❤️\n\nRecheio de Brigadeiro \n🎈300g de cobertura Premium Mavalério (usei sabor chocolate ao leite) \n🎈20g de chocolate em pó 50% cacau mavalério \n🎈150g de leite condensado \n\nPara montagem \n🎈Palitos e biscoito doce de sua preferência \n\nPara banhar \n🎈Cobertura Premium Mavalério \n🎈Granulado macio Mavalério sabor chocolate',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M32S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '671',
      likeCount: '73',
      dislikeCount: '1',
      favoriteCount: '0',
      commentCount: '3',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/qOtPvgbotOw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'cXr8llr-cmKM4-3OnCHq8VQZ9ew',
    id: 'lfqqMKLiJ3M',
    snippet: {
      publishedAt: '2022-10-19T10:15:02Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Brigadeiro de amêndoas maravilhoso!!!!',
      description:
        '❤️🍫Esse brigadeiro é de comer rezando!!!! \n❤️Já salva essa receita e compartilha com a pessoa que merece provar essa delícia! \n\n🍫Brigadeiros de amêndoas \n\n🍫395g de leite condensado \n❤️5g de farinha de trigo \n🍫10g de manteiga ou margarina \n❤️Aroma de amêndoas Mavalério a gosto \n🍫30g de amêndoas trituradas \n\nPara banhar \n❤️400g de cobertura Premium Mavalério sabor chocolate branco \n🍫50g de cobertura Premium Mavalério sabor chocolate meio amargo \n❤️Amêndoas em lâminas',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/lfqqMKLiJ3M/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/lfqqMKLiJ3M/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/lfqqMKLiJ3M/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/lfqqMKLiJ3M/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/lfqqMKLiJ3M/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Brigadeiro de amêndoas maravilhoso!!!!',
        description:
          '❤️🍫Esse brigadeiro é de comer rezando!!!! \n❤️Já salva essa receita e compartilha com a pessoa que merece provar essa delícia! \n\n🍫Brigadeiros de amêndoas \n\n🍫395g de leite condensado \n❤️5g de farinha de trigo \n🍫10g de manteiga ou margarina \n❤️Aroma de amêndoas Mavalério a gosto \n🍫30g de amêndoas trituradas \n\nPara banhar \n❤️400g de cobertura Premium Mavalério sabor chocolate branco \n🍫50g de cobertura Premium Mavalério sabor chocolate meio amargo \n❤️Amêndoas em lâminas',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT56S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '3474',
      likeCount: '305',
      dislikeCount: '7',
      favoriteCount: '0',
      commentCount: '5',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/lfqqMKLiJ3M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'BqY0HDGXhDnbw9unRPuoViMkg8w',
    id: 'UNsxybKUspo',
    snippet: {
      publishedAt: '2022-10-18T17:00:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'bombom mini bolo para fazer e vender!',
      description:
        '🍫Bombom mini bolo 🍰 \n\nCasquinha \n🍫400g de cobertura Premium Mavalério (usei sabor chocolate ao leite) \n\nRecheio \n🍫395g de leite condensado \n🍫20g de pó para preparo de sobremesa sabor morango Mavalério \n\nPara finalizar \n🍫ChocoPower ball mini colorido',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/UNsxybKUspo/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/UNsxybKUspo/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/UNsxybKUspo/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/UNsxybKUspo/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/UNsxybKUspo/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'bombom mini bolo para fazer e vender!',
        description:
          '🍫Bombom mini bolo 🍰 \n\nCasquinha \n🍫400g de cobertura Premium Mavalério (usei sabor chocolate ao leite) \n\nRecheio \n🍫395g de leite condensado \n🍫20g de pó para preparo de sobremesa sabor morango Mavalério \n\nPara finalizar \n🍫ChocoPower ball mini colorido',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT58S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '1469391',
      likeCount: '122315',
      dislikeCount: '2078',
      favoriteCount: '0',
      commentCount: '343',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/UNsxybKUspo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'de-R71xrYTzB-9Yh_Hj1JnPl3jU',
    id: '-LBrTdMf_xs',
    snippet: {
      publishedAt: '2022-10-03T01:00:12Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'receita de Cup cake oreo feito em 2 minutos',
      description:
        '🧁Cup cake oreo \n\n🧁1 ovo \n🧁50g de açúcar \n🧁30ml de óleo \n🧁10g de chocolate em pó 70%cacau \n🧁50ml de leite\n🧁80g farinha de trigo \n🧁5g fermento em pó \n\n🧁Cobertura \n🧁150ml de Chantily vegetal bem gelado\n🧁5 biscoitos',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/-LBrTdMf_xs/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/-LBrTdMf_xs/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/-LBrTdMf_xs/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/-LBrTdMf_xs/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/-LBrTdMf_xs/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'receita de Cup cake oreo feito em 2 minutos',
        description:
          '🧁Cup cake oreo \n\n🧁1 ovo \n🧁50g de açúcar \n🧁30ml de óleo \n🧁10g de chocolate em pó 70%cacau \n🧁50ml de leite\n🧁80g farinha de trigo \n🧁5g fermento em pó \n\n🧁Cobertura \n🧁150ml de Chantily vegetal bem gelado\n🧁5 biscoitos',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT58S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '6097',
      likeCount: '716',
      dislikeCount: '10',
      favoriteCount: '0',
      commentCount: '10',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/-LBrTdMf_xs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'TBc9DzRqslu2kjfoYbuDLCmYR2s',
    id: 'Us-qL5Yucws',
    snippet: {
      publishedAt: '2022-10-02T01:00:13Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'como fazer milhares de Pastilhas drageadas com sabor de infância ❤️',
      description:
        'uma super dica pra vc que adora praticidade !!!!\n\nUsei apenas Cobertura sabor chocolate (linha Premium Mavalerio e confeitos)',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Us-qL5Yucws/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Us-qL5Yucws/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/Us-qL5Yucws/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/Us-qL5Yucws/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/Us-qL5Yucws/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'como fazer milhares de Pastilhas drageadas com sabor de infância ❤️',
        description:
          'uma super dica pra vc que adora praticidade !!!!\n\nUsei apenas Cobertura sabor chocolate (linha Premium Mavalerio e confeitos)',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT51S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '4287',
      likeCount: '350',
      dislikeCount: '4',
      favoriteCount: '0',
      commentCount: '3',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/Us-qL5Yucws" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'RTj9Z0RsO-Gbgf50QvEBr4egRD4',
    id: '6QkI2ZQZ8os',
    snippet: {
      publishedAt: '2022-09-29T16:14:48Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Essa é uma das 20 aulas do meu curso completíssimo e on-line !',
      description:
        'Até amanhã está com descontão de 85% de desconto de 199,00 por 29,85 \nClick no link ou Copie e cole no seu navegador! \n\nhttps://pay.hotmart.com/K62274726B?off=1v94wr2r',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/6QkI2ZQZ8os/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/6QkI2ZQZ8os/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/6QkI2ZQZ8os/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/6QkI2ZQZ8os/sddefault.jpg',
          width: 640,
          height: 480,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Essa é uma das 20 aulas do meu curso completíssimo e on-line !',
        description:
          'Até amanhã está com descontão de 85% de desconto de 199,00 por 29,85 \nClick no link ou Copie e cole no seu navegador! \n\nhttps://pay.hotmart.com/K62274726B?off=1v94wr2r',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT35S',
      dimension: '2d',
      definition: 'sd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '516',
      likeCount: '64',
      dislikeCount: '1',
      favoriteCount: '0',
      commentCount: '3',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="360" src="//www.youtube.com/embed/6QkI2ZQZ8os" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'VSeV8vUIgm79gfQ8lKA3Tc89I8g',
    id: '0U3laAK1F-k',
    snippet: {
      publishedAt: '2022-09-29T11:30:11Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Receita de  Brownie branco “Blondie” pra você!',
      description:
        '🍫 Brownie Branco "Blondie" \n\n🍫450g de cobertura Premium Mavalério sabor chocolate branco \n🍫5 gemas \n🍫5 claras em neve \n🍫Gotas de aroma de amêndoas Mavalério a gosto \n🍫150g de amêndoas em lâminas \n🍫50g Açúcar gelado Mavalério',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/0U3laAK1F-k/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/0U3laAK1F-k/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/0U3laAK1F-k/hqdefault.jpg',
          width: 480,
          height: 360,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Receita de  Brownie branco “Blondie” pra você!',
        description:
          '🍫 Brownie Branco "Blondie" \n\n🍫450g de cobertura Premium Mavalério sabor chocolate branco \n🍫5 gemas \n🍫5 claras em neve \n🍫Gotas de aroma de amêndoas Mavalério a gosto \n🍫150g de amêndoas em lâminas \n🍫50g Açúcar gelado Mavalério',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M24S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '507',
      likeCount: '91',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/0U3laAK1F-k" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'yOCQOzeeTv9O_HZaAw3eH28IEEI',
    id: 'El2ojiqu50o',
    snippet: {
      publishedAt: '2022-09-27T16:27:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'IMPERDÍVEL!!!! DURANTE 72HORAS DESCONTO DE 85% NO MEU CURSO!!!!',
      description:
        'Curso completo de doces no microondas,\nSao 20 video receitas divididas em 5 módulos :\nBolos;\nDocinhos:\nDoces de vitrine;\nBiscoitos;\nChocolates.\n+ Material de apoio completo para imprimir!!!!\nDe 199,00 por 29,85 durante 72 horas!!!!\npara adquirir ,copie e cole o link promocional no seu navegador\n\nhttps://pay.hotmart.com/K62274726B?off=1v94wr2r',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/El2ojiqu50o/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/El2ojiqu50o/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/El2ojiqu50o/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/El2ojiqu50o/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/El2ojiqu50o/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'IMPERDÍVEL!!!! DURANTE 72HORAS DESCONTO DE 85% NO MEU CURSO!!!!',
        description:
          'Curso completo de doces no microondas,\nSao 20 video receitas divididas em 5 módulos :\nBolos;\nDocinhos:\nDoces de vitrine;\nBiscoitos;\nChocolates.\n+ Material de apoio completo para imprimir!!!!\nDe 199,00 por 29,85 durante 72 horas!!!!\npara adquirir ,copie e cole o link promocional no seu navegador\n\nhttps://pay.hotmart.com/K62274726B?off=1v94wr2r',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT58S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '1699',
      likeCount: '203',
      dislikeCount: '3',
      favoriteCount: '0',
      commentCount: '7',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/El2ojiqu50o" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 't18gciAigLYWjcqBhSFbTJDy394',
    id: '8ZIMEDboFxE',
    snippet: {
      publishedAt: '2022-09-23T01:00:14Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Como fazer Bala Baiana caramelizada !!!!!',
      description:
        '🥥🌴Bala Baiana de maracujá \n\nMassa \n🥥395g de leite condensado \n🥥10g farinha de trigo \n🥥10g manteiga ou margarina \n🥥100g coco ralado \n🥥10g Pó para preparo de sobremesa sabor Maracujá Mavalério \nDica: coloque o pó com o fogo desligado!!!! \n\nCalda para banhar \nLeve ao fogo baixo até derreter completamente \n🥥500g de açúcar colorido Mavalério (usei o branco) \n\n✨Dica de ouro!!! \nSe vc for comercializar, embale as balas em papel celofane de torção imediatamente após secar Caso contrário, o caramelo derreterá! \n\nValidade embalada: 5 dias',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/8ZIMEDboFxE/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/8ZIMEDboFxE/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/8ZIMEDboFxE/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/8ZIMEDboFxE/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/8ZIMEDboFxE/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      tags: ['youtube.com/@MexeuTaPronto'],
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Como fazer Bala Baiana caramelizada !!!!!',
        description:
          '🥥🌴Bala Baiana de maracujá \n\nMassa \n🥥395g de leite condensado \n🥥10g farinha de trigo \n🥥10g manteiga ou margarina \n🥥100g coco ralado \n🥥10g Pó para preparo de sobremesa sabor Maracujá Mavalério \nDica: coloque o pó com o fogo desligado!!!! \n\nCalda para banhar \nLeve ao fogo baixo até derreter completamente \n🥥500g de açúcar colorido Mavalério (usei o branco) \n\n✨Dica de ouro!!! \nSe vc for comercializar, embale as balas em papel celofane de torção imediatamente após secar Caso contrário, o caramelo derreterá! \n\nValidade embalada: 5 dias',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M1S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '53448',
      likeCount: '3091',
      dislikeCount: '87',
      favoriteCount: '0',
      commentCount: '25',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/8ZIMEDboFxE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'TTDBp_2SveAroKyoP35_UP9HiJo',
    id: 'VVt2gEBSBcM',
    snippet: {
      publishedAt: '2022-09-22T02:00:15Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Brigadeiro de churros que derrete na boca!',
      description:
        '🍬Brigadeiro de churros \n\n🍬395g de leite condensado \n🍬5g de farinha de trigo \n🍬10g de manteiga ou margarina \n🍬5g de canela em pó \nLeve tudo ao fogo até soltar da panela em seguida acrescente \n🍬30g de doce de leite Oliveira, misture bem com o fogo desligado! \n\n🍬Para finalizar \n🍬Açúcar com canela \n🍬Pitangas de doce de leite Oliveira \n\nValidade 7 dias \nPeso: 25g cada',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/VVt2gEBSBcM/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/VVt2gEBSBcM/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/VVt2gEBSBcM/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/VVt2gEBSBcM/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/VVt2gEBSBcM/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Brigadeiro de churros que derrete na boca!',
        description:
          '🍬Brigadeiro de churros \n\n🍬395g de leite condensado \n🍬5g de farinha de trigo \n🍬10g de manteiga ou margarina \n🍬5g de canela em pó \nLeve tudo ao fogo até soltar da panela em seguida acrescente \n🍬30g de doce de leite Oliveira, misture bem com o fogo desligado! \n\n🍬Para finalizar \n🍬Açúcar com canela \n🍬Pitangas de doce de leite Oliveira \n\nValidade 7 dias \nPeso: 25g cada',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT56S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '5586',
      likeCount: '469',
      dislikeCount: '6',
      favoriteCount: '0',
      commentCount: '4',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/VVt2gEBSBcM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'adPxeDHgAhtMXkB--nyz_mCSrdY',
    id: 'Hcvcty8DiFg',
    snippet: {
      publishedAt: '2022-09-21T01:45:10Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'A melhor Bala de coco com chocolate!!! Sem fogão e sem complicação!!!',
      description:
        'Bala de coco com chocolate 🍫 🥥\n\n🥥🍫250g de Snow Sugar Mavalério \n🥥🍫60g de chocolate em pó \n🥥🍫70%cacau Mavalério \n🥥🍫50ml de leite de coco \n🥥🍫Coco ralado para dar acabamento',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Hcvcty8DiFg/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Hcvcty8DiFg/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/Hcvcty8DiFg/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/Hcvcty8DiFg/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/Hcvcty8DiFg/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'A melhor Bala de coco com chocolate!!! Sem fogão e sem complicação!!!',
        description:
          'Bala de coco com chocolate 🍫 🥥\n\n🥥🍫250g de Snow Sugar Mavalério \n🥥🍫60g de chocolate em pó \n🥥🍫70%cacau Mavalério \n🥥🍫50ml de leite de coco \n🥥🍫Coco ralado para dar acabamento',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M32S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '795',
      likeCount: '134',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '0',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/Hcvcty8DiFg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '0GGCeHT4YhL0XlKaE8TsT4kJKdA',
    id: 'uF6Fwt3I9fM',
    snippet: {
      publishedAt: '2022-09-16T23:50:11Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Dica para deixar sua massa de brigadeiro perfeita!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/uF6Fwt3I9fM/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/uF6Fwt3I9fM/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/uF6Fwt3I9fM/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/uF6Fwt3I9fM/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/uF6Fwt3I9fM/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Dica para deixar sua massa de brigadeiro perfeita!',
        description: '',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT53S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '3367',
      likeCount: '342',
      dislikeCount: '8',
      favoriteCount: '0',
      commentCount: '1',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/uF6Fwt3I9fM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'BVC2ZA_PlPI1rNAzjtbF8s7rdeM',
    id: 'WwBwqSmuruI',
    snippet: {
      publishedAt: '2022-09-15T23:50:12Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Docinho que já sai na forminha de chocolate!!!!',
      description: '',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/WwBwqSmuruI/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/WwBwqSmuruI/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/WwBwqSmuruI/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/WwBwqSmuruI/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/WwBwqSmuruI/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Docinho que já sai na forminha de chocolate!!!!',
        description: '',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT59S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '472781',
      likeCount: '48268',
      dislikeCount: '637',
      favoriteCount: '0',
      commentCount: '109',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/WwBwqSmuruI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'Mhle2JiBLh71eHvS2Rvuuoa_C_E',
    id: '3y7FKLJyoz8',
    snippet: {
      publishedAt: '2022-09-14T23:49:52Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Pão doce feito em 5 minutos na airfryer',
      description:
        'Pão doce na Airfryer\n\n✨Massa\n✨5g de fermento biológico seco instantâneo Dr. Oetker \n✨30g de açúcar de confeiteiro impalpável Snow Sugar Mavalério \n✨20g de margarina ou manteiga \n✨120ml de água morna \n✨Gotas de aroma de baunilha Mavalério \n✨1 ovo \n✨250g de farinha de trigo \n\n✨Recheio \n✨500ml de leite \n✨200g Recheio creme confeiteiro Mavalério \n\n✨Açúcar gelado Mavalério para finalizar \n\nDica para assar: \n✨Tempo na airfryer  5 minutos 180graus \n✨Se preferir pode fazer no forno (180graus até dourar)',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/3y7FKLJyoz8/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/3y7FKLJyoz8/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/3y7FKLJyoz8/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/3y7FKLJyoz8/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/3y7FKLJyoz8/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Pão doce feito em 5 minutos na airfryer',
        description:
          'Pão doce na Airfryer\n\n✨Massa\n✨5g de fermento biológico seco instantâneo Dr. Oetker \n✨30g de açúcar de confeiteiro impalpável Snow Sugar Mavalério \n✨20g de margarina ou manteiga \n✨120ml de água morna \n✨Gotas de aroma de baunilha Mavalério \n✨1 ovo \n✨250g de farinha de trigo \n\n✨Recheio \n✨500ml de leite \n✨200g Recheio creme confeiteiro Mavalério \n\n✨Açúcar gelado Mavalério para finalizar \n\nDica para assar: \n✨Tempo na airfryer  5 minutos 180graus \n✨Se preferir pode fazer no forno (180graus até dourar)',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M17S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '1144',
      likeCount: '137',
      dislikeCount: '2',
      favoriteCount: '0',
      commentCount: '6',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/3y7FKLJyoz8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: '8G3nE2UEq7j8UbiZ6pSPKDeg0_k',
    id: 'Y09jK6pBBDc',
    snippet: {
      publishedAt: '2022-08-29T13:48:12Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'A moda agora  é Comic cake!!!! Já ouviu falar???',
      description:
        'Segura esse novidade que chegou com tudo!!!! \n\nConhece “Comic Cake”? \n\nPrepare-se para as encomendas!!! \n\n😋🎂Comic Cake \nMassa:\n😋2 ovos \n😋80ml de óleo \n😋100g de açúcar \n😋100ml de leite \n😋Aroma de baunilha branca Mavalério a gosto \n😋180g de farinha de trigo \n😋10g de fermento em pó Dr Oetker \n\nRecheio \n😋Prepare uma receita de cobertura Marshmallow Mavalério seguindo as instruções da embalagem e morangos picados a gosto. \n\n😋Para desenhar Cobertura Premium sabor chocolate meio amargo Mavalério.',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/Y09jK6pBBDc/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/Y09jK6pBBDc/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/Y09jK6pBBDc/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/Y09jK6pBBDc/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/Y09jK6pBBDc/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'A moda agora  é Comic cake!!!! Já ouviu falar???',
        description:
          'Segura esse novidade que chegou com tudo!!!! \n\nConhece “Comic Cake”? \n\nPrepare-se para as encomendas!!! \n\n😋🎂Comic Cake \nMassa:\n😋2 ovos \n😋80ml de óleo \n😋100g de açúcar \n😋100ml de leite \n😋Aroma de baunilha branca Mavalério a gosto \n😋180g de farinha de trigo \n😋10g de fermento em pó Dr Oetker \n\nRecheio \n😋Prepare uma receita de cobertura Marshmallow Mavalério seguindo as instruções da embalagem e morangos picados a gosto. \n\n😋Para desenhar Cobertura Premium sabor chocolate meio amargo Mavalério.',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M15S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: true,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '734',
      likeCount: '82',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '5',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/Y09jK6pBBDc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'W4d5GaDwvq_QS1WtbUlEuRZC3wo',
    id: 'FGE54w4Cx1M',
    snippet: {
      publishedAt: '2022-08-12T21:15:13Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Calda de caramelo que dura 3 meses',
      description: 'Com essa receita você terá caramelo por 3 meses!!!! \nAcompanhe o vídeo!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/FGE54w4Cx1M/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/FGE54w4Cx1M/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/FGE54w4Cx1M/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/FGE54w4Cx1M/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/FGE54w4Cx1M/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Calda de caramelo que dura 3 meses',
        description: 'Com essa receita você terá caramelo por 3 meses!!!! \nAcompanhe o vídeo!',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT1M49S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '828',
      likeCount: '143',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '9',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/FGE54w4Cx1M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'qDxc7ludPiXlY32uHjxYDjlOAFg',
    id: 'hS6gduRYuQ8',
    snippet: {
      publishedAt: '2022-08-11T21:00:17Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Chega de fazer bolo FIT ruim e complicado!! Fiz essa receita no microondas em 5 minutos !',
      description: 'Todas as dicas e  receita no video!!!!!',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/hS6gduRYuQ8/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/hS6gduRYuQ8/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/hS6gduRYuQ8/hqdefault.jpg',
          width: 480,
          height: 360,
        },
        standard: {
          url: 'https://i.ytimg.com/vi/hS6gduRYuQ8/sddefault.jpg',
          width: 640,
          height: 480,
        },
        maxres: {
          url: 'https://i.ytimg.com/vi/hS6gduRYuQ8/maxresdefault.jpg',
          width: 1280,
          height: 720,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Chega de fazer bolo FIT ruim e complicado!! Fiz essa receita no microondas em 5 minutos !',
        description: 'Todas as dicas e  receita no video!!!!!',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT3M56S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '774',
      likeCount: '128',
      dislikeCount: '1',
      favoriteCount: '0',
      commentCount: '10',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/hS6gduRYuQ8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
  {
    kind: 'youtube#video',
    etag: 'cwDo-59QYcKmKsBVAFa-wmJwDgI',
    id: 'MBdCb5osxnA',
    snippet: {
      publishedAt: '2022-08-09T15:00:14Z',
      channelId: 'UCNSqcSjCbJlPF-03shtD3Kg',
      title: 'Bolo perfeito que já sai recheado do forno!',
      description:
        'Massa: \n150g ovos \n200g açúcar \n100ml de óleo \n200ml de água \n100g chocolate em pó 70% cacau \n300g de farinha de trigo \n20g fermento em pó \n\nRecheio \n1 litro de leite \n400g de Recheio creme confeiteiro \n100g de coco ralado \n\nCobertura \n150g Chocolate meio amargo derretido\n200g creme de leite \nMisture e aplique no bolo',
      thumbnails: {
        default: {
          url: 'https://i.ytimg.com/vi/MBdCb5osxnA/default.jpg',
          width: 120,
          height: 90,
        },
        medium: {
          url: 'https://i.ytimg.com/vi/MBdCb5osxnA/mqdefault.jpg',
          width: 320,
          height: 180,
        },
        high: {
          url: 'https://i.ytimg.com/vi/MBdCb5osxnA/hqdefault.jpg',
          width: 480,
          height: 360,
        },
      },
      channelTitle: 'Mexeu Ta Pronto',
      categoryId: '27',
      liveBroadcastContent: 'none',
      defaultLanguage: 'pt',
      localized: {
        title: 'Bolo perfeito que já sai recheado do forno!',
        description:
          'Massa: \n150g ovos \n200g açúcar \n100ml de óleo \n200ml de água \n100g chocolate em pó 70% cacau \n300g de farinha de trigo \n20g fermento em pó \n\nRecheio \n1 litro de leite \n400g de Recheio creme confeiteiro \n100g de coco ralado \n\nCobertura \n150g Chocolate meio amargo derretido\n200g creme de leite \nMisture e aplique no bolo',
      },
      defaultAudioLanguage: 'pt-BR',
    },
    contentDetails: {
      duration: 'PT4M10S',
      dimension: '2d',
      definition: 'hd',
      caption: 'false',
      licensedContent: true,
      contentRating: {},
      projection: 'rectangular',
      hasCustomThumbnail: false,
    },
    status: {
      uploadStatus: 'processed',
      privacyStatus: 'public',
      license: 'youtube',
      embeddable: true,
      publicStatsViewable: true,
      madeForKids: false,
    },
    statistics: {
      viewCount: '822',
      likeCount: '147',
      dislikeCount: '0',
      favoriteCount: '0',
      commentCount: '8',
    },
    player: {
      embedHtml:
        '<iframe width="480" height="270" src="//www.youtube.com/embed/MBdCb5osxnA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>',
    },
    metadados: {
      shares: 0,
      averageViewDuration: 0,
      averageViewPercentage: 0,
      estimatedMinutesWatched: 0,
      subscribersGained: 0,
      elapsedVideoTimeRatio: [],
      relativeRetentionPerformance: [],
      audienceWatchRatio: [],
      insights: {
        elapsedVideoTimeRatio: [],
        relativeRetentionPerformance: [],
        audienceWatchRatio: [],
      },
      viewsRate: null,
    },
    referencias: false,
  },
]

export const getMediaFeed = {
  medias: [
    {
      obtidoEm: '2023-09-01T17:26:10.787Z',
      origem: 'instagram',
      uid: '18367981141071748',
      link: 'https://www.instagram.com/reel/CwGSm3kt5dh/',
      tipo: 'video',
      upvotes: 381,
      comentarios: 29,
      criadoEm: '2023-08-18T19:51:16.000Z',
      lastUpdate: '2023-09-01T17:26:10.787Z',
      legenda: 'minha conta bancária aumentou automaticamente no mínimo 10 dígitos com esse cabelo hidratado diz aí. 🖤',
      tags: [],
      mentions: [],
      ad: false,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lga3-2.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=kizNz86mEJYAX9-BXKZ&_nc_ht=scontent-lga3-2.xx&edm=AM6HXa8EAAAA&oh=00_AfDS0wMURgR_QnpjFhl0-NnIiO-HszyfNIo1vVG8tLtfaA&oe=64F76AD4',
        nome: 'Nathália Melandre',
      },
      metadados: {
        idFacebook: '18367981141071748',
        productType: 'reels',
      },
      videos: {
        resolucaoPadrao: {
          url: '',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: '',
          width: 480,
          height: 480,
        },
      },
      imagens: {
        resolucaoPadrao: {
          url: 'https://scontent-lga3-2.cdninstagram.com/v/t51.36329-15/368572611_24278654611721845_5800845576536757332_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=8ae9d6&_nc_ohc=VhKvwvUirDsAX9Yedbf&_nc_ht=scontent-lga3-2.cdninstagram.com&edm=AM6HXa8EAAAA&oh=00_AfC7dimnwfFRHNoymn1U4KSFfcy6G2oMpJxdHkUj3MkCeQ&oe=64F7A81B',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://scontent-lga3-2.cdninstagram.com/v/t51.36329-15/368572611_24278654611721845_5800845576536757332_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=8ae9d6&_nc_ohc=VhKvwvUirDsAX9Yedbf&_nc_ht=scontent-lga3-2.cdninstagram.com&edm=AM6HXa8EAAAA&oh=00_AfC7dimnwfFRHNoymn1U4KSFfcy6G2oMpJxdHkUj3MkCeQ&oe=64F7A81B',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://scontent-lga3-2.cdninstagram.com/v/t51.36329-15/368572611_24278654611721845_5800845576536757332_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=8ae9d6&_nc_ohc=VhKvwvUirDsAX9Yedbf&_nc_ht=scontent-lga3-2.cdninstagram.com&edm=AM6HXa8EAAAA&oh=00_AfC7dimnwfFRHNoymn1U4KSFfcy6G2oMpJxdHkUj3MkCeQ&oe=64F7A81B',
          width: 150,
          height: 150,
        },
      },
    },
    {
      _id: '64dbd9af9166f2a3b94d9d1b',
      origem: 'instagram',
      uid: '18005488834786712',
      __v: 0,
      ad: true,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18005488834786712/carousel_0_namelandre_18005488834786712.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18005488834786712/carousel_1_namelandre_18005488834786712.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18005488834786712/carousel_2_namelandre_18005488834786712.jpg',
        },
      ],
      comentarios: 129,
      criadoEm: '2023-08-15T19:44:02.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18005488834786712/image_namelandre_18005488834786712.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18005488834786712/image_namelandre_18005488834786712.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18005488834786712/image_namelandre_18005488834786712.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.356Z',
      legenda:
        'Mais um registro do nosso piquenique. Ser criança é descobrir brincando. É imaginar diferentes mundos e deixar aflorar o espírito de aventura. Para quem cuida delas, o desafio é dar liberdade para que as crianças explorem o desconhecido e, ao mesmo tempo, adquiram um sólido repertório de valores para o futuro. E aih eu conto com Chamyto da @aiogurterianestle, alimento que contém lactobacilos vivos, cálcio, zinco e muito sabor pra me ajudar nessa missão. Assim fica mais gostoso neh?!\n\n*publicidade',
      link: 'https://www.instagram.com/p/Cv-jffQpuyV/',
      links: [],
      mentions: ['aiogurterianestle'],
      metadados: {
        idFacebook: '18005488834786712',
        isEstimated: false,
        engagement: 682,
        saved: 8,
        impressions: 2577,
        reach: 2104,
        effective_reach: 0.040223292804159975,
        tax_engagement: 0.2646488164532402,
        comments_by_like: 0.23669724770642203,
        comments_rate: 0.050058207217694994,
      },
      obtidoEm: '2023-08-18T15:01:09.356Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 545,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '64d7bae99166f2a3b9b93dfd',
      origem: 'instagram',
      uid: '18229668373233121',
      __v: 0,
      ad: false,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_0_namelandre_18229668373233121.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_1_namelandre_18229668373233121.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_2_namelandre_18229668373233121.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_3_namelandre_18229668373233121.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_4_namelandre_18229668373233121.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_5_namelandre_18229668373233121.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/carousel_6_namelandre_18229668373233121.jpg',
        },
      ],
      comentarios: 96,
      criadoEm: '2023-08-12T16:36:40.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/image_namelandre_18229668373233121.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/image_namelandre_18229668373233121.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18229668373233121/image_namelandre_18229668373233121.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.449Z',
      legenda:
        'gente 1 anúncio: Nickolas assumiu a conta dele do instagram. apagou tudo mudou @ e colocou uma foto de perfil de costas. não tive direito a opinar apenas entreguei a conta q eu mesma criei. será o fim da era low profile? não sabemos talvez ele tranque o perfil que por enquanto n tem publicações. ps: a calça da 1º foto eh minha e em seguida o pé 39. 🫠',
      link: 'https://www.instagram.com/p/Cv2fqivrETi/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '18229668373233121',
        isEstimated: false,
        engagement: 1486,
        saved: 7,
        impressions: 9071,
        reach: 6287,
        effective_reach: 0.12019194004741149,
        tax_engagement: 0.16381876309116966,
        comments_by_like: 0.06941431670281996,
        comments_rate: 0.010583177157975967,
      },
      obtidoEm: '2023-08-18T15:01:09.449Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 1383,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '64d6a1a99166f2a3b91d4da2',
      origem: 'instagram',
      uid: '17994625102952798',
      __v: 0,
      ad: true,
      comentarios: 60,
      criadoEm: '2023-08-11T20:34:38.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17994625102952798/image_namelandre_17994625102952798.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17994625102952798/image_namelandre_17994625102952798.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17994625102952798/image_namelandre_17994625102952798.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.586Z',
      legenda:
        'Tudo que rolou no Ipa Day Lagunitas com @lagunitasbeer. Teve close, teve Ipa Lagunitas claro, flash tattoo, doguinhos, música e muita diversão. Eu amei e to pronta pra próxima. #apreciecommoderação #lagunitasbeer *publicidade',
      link: 'https://www.instagram.com/reel/Cv0V_X-rBZl/',
      links: [],
      mentions: ['lagunitasbeer.'],
      metadados: {
        idFacebook: '17994625102952798',
        isEstimated: true,
        engagement: 596,
        plays: 13612,
        saved: 7,
        reach: 13389,
        effective_reach: 0.2559646707960541,
        tax_engagement: 0.043784895680282106,
        comments_by_like: 0.11342155009451796,
        comments_rate: 0.004407875404055245,
      },
      obtidoEm: '2023-08-18T15:01:09.586Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: ['apreciecommodera', 'lagunitasbeer'],
      tipo: 'video',
      upvotes: 529,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17994625102952798/video_namelandre_17994625102952798.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17994625102952798/video_namelandre_17994625102952798.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64d428cf9166f2a3b942104c',
      origem: 'instagram',
      uid: '17943964571580968',
      __v: 0,
      ad: true,
      comentarios: 143,
      criadoEm: '2023-08-09T23:41:19.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17943964571580968/image_namelandre_17943964571580968.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17943964571580968/image_namelandre_17943964571580968.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17943964571580968/image_namelandre_17943964571580968.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.641Z',
      legenda:
        'Já passou a palavra do skincare pro seu adolescente hoje?! \n\nEsses são alguns dos produtos antiacne da @sallve, a linha perfeita pro seu adolescente de pele oleosa. São fórmulas inspiradas por acnes reais que reúnem ativos poderosos que auxiliam o tratamento de cravos e espinhas. O uso diário dos produtos controla a oleosidade sem ressecar, acalma a irritação e vermelhidão da pele, além de suavizar cicatrizes e marcas de acne. Tudo isso mantendo a barreira protetora da pele íntegra e saudável. \n\nEntão vc que não sabia pode onde começar a orientar seu filho com os cuidados pra uma pele saudável acabou de encontrar a solução. \n\nQuem gostou da um @sallve! 💚 *publicidade',
      link: 'https://www.instagram.com/reel/Cvvh0HVP5YH/',
      links: [],
      mentions: ['sallve'],
      metadados: {
        idFacebook: '17943964571580968',
        isEstimated: true,
        engagement: 648,
        plays: 4095,
        saved: 9,
        reach: 3418,
        effective_reach: 0.06534373327215723,
        tax_engagement: 0.15824175824175823,
        comments_by_like: 0.28830645161290325,
        comments_rate: 0.03492063492063492,
      },
      obtidoEm: '2023-08-18T15:01:09.640Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 496,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17943964571580968/video_namelandre_17943964571580968.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17943964571580968/video_namelandre_17943964571580968.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64ca774f9166f2a3b9d12872',
      origem: 'instagram',
      uid: '17886954959822990',
      __v: 0,
      ad: false,
      comentarios: 50,
      criadoEm: '2023-08-02T15:24:22.000Z',
      errorType: 'copyright',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17886954959822990/image_namelandre_17886954959822990.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17886954959822990/image_namelandre_17886954959822990.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17886954959822990/image_namelandre_17886954959822990.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.714Z',
      legenda:
        'Um resumão de como eh a @grapadigital. Dream team e eh o meu! ❤️ E aih eh assim que vcs imaginavam que fosse uma agência de mkt de influência!? 😎',
      link: 'https://www.instagram.com/reel/CvcnYoDthDb/',
      links: [],
      mentions: ['grapadigital.'],
      metadados: {
        idFacebook: '17886954959822990',
        isEstimated: true,
        engagement: 358,
        plays: 6081,
        saved: 13,
        reach: 4913,
        effective_reach: 0.09392444750324998,
        tax_engagement: 0.05887189606972537,
        comments_by_like: 0.1694915254237288,
        comments_rate: 0.0082223318533136,
      },
      obtidoEm: '2023-08-18T15:01:09.714Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 295,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64c8131d9166f2a3b9765c85',
      origem: 'instagram',
      uid: '18108653572321878',
      __v: 0,
      ad: false,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/carousel_0_namelandre_18108653572321878.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/carousel_1_namelandre_18108653572321878.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/carousel_2_namelandre_18108653572321878.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/carousel_3_namelandre_18108653572321878.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/carousel_4_namelandre_18108653572321878.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/carousel_5_namelandre_18108653572321878.jpg',
        },
      ],
      comentarios: 29,
      criadoEm: '2023-07-31T19:42:32.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/image_namelandre_18108653572321878.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/image_namelandre_18108653572321878.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18108653572321878/image_namelandre_18108653572321878.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.772Z',
      legenda: 'aleatórias de julho. 🖤',
      link: 'https://www.instagram.com/p/CvX7ZU3L8yL/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '18108653572321878',
        isEstimated: false,
        engagement: 216,
        saved: 3,
        impressions: 1527,
        reach: 1322,
        effective_reach: 0.02527338074481915,
        tax_engagement: 0.14145383104125736,
        comments_by_like: 0.15760869565217392,
        comments_rate: 0.01899148657498363,
      },
      obtidoEm: '2023-08-18T15:01:09.772Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 184,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '64c7eff29166f2a3b9134b33',
      origem: 'instagram',
      uid: '17858263502991215',
      __v: 0,
      ad: false,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/carousel_0_namelandre_17858263502991215.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/carousel_1_namelandre_17858263502991215.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/carousel_2_namelandre_17858263502991215.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/carousel_3_namelandre_17858263502991215.jpg',
        },
      ],
      comentarios: 14,
      criadoEm: '2023-07-31T17:19:21.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/image_namelandre_17858263502991215.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/image_namelandre_17858263502991215.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17858263502991215/image_namelandre_17858263502991215.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-07-31T18:01:14.960Z',
      legenda: 'aleatórias de julho. 🖤',
      link: 'https://www.instagram.com/p/CvXrAjWLZew/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '17858263502991215',
        isEstimated: false,
        engagement: 114,
        saved: 0,
        impressions: 237,
        reach: 237,
        effective_reach: 0.0045308557008488185,
        tax_engagement: 0.4810126582278481,
        comments_by_like: 0.14,
        comments_rate: 0.05907172995780591,
        oldEstimatedMetrics: '',
      },
      obtidoEm: '2023-07-31T18:01:14.960Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 100,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent.fmaa10-1.fna.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_eui2=AeELiosngP7n8jDIGElmEJ3zKbnxZyljjjApufFnKWOOMB7P6aKNrQE_P-idtWxadLs&_nc_ohc=5--t0yoWvykAX8DpqvX&_nc_ht=scontent.fmaa10-1.fna&edm=AL-3X8kEAAAA&oh=00_AfAweo2G4yWdGjhXmoDDKKt6tojmSEUrfyqyhLD3sravNA&oe=64CDE394',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '64c2d4899166f2a3b98500cd',
      origem: 'instagram',
      uid: '18090132481348424',
      __v: 0,
      ad: false,
      comentarios: 86,
      criadoEm: '2023-07-27T20:01:25.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18090132481348424/image_namelandre_18090132481348424.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18090132481348424/image_namelandre_18090132481348424.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18090132481348424/image_namelandre_18090132481348424.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.842Z',
      legenda:
        'Nada melhor que uma tarde ao ar livre com Nick onde podemos curtir a natureza, conversar, jogar bola etc. Pra ficar melhor ainda não poderia faltar um piquenique com Chamyto da @aiogurterianestle, alimento que contém lactobacilos vivos, cálcio, zinco e muito sabor. É a união do cuidado que um responsável tem por seus pequenos (as vezes nem tão pequenos assim) com a diversão de aprender brincando. ❤️',
      link: 'https://www.instagram.com/reel/CvNpzF1J8D-/',
      links: [],
      mentions: ['aiogurterianestle'],
      metadados: {
        idFacebook: '18090132481348424',
        isEstimated: true,
        engagement: 433,
        plays: 4385,
        saved: 5,
        reach: 3913,
        effective_reach: 0.07480691290051235,
        tax_engagement: 0.09874572405929305,
        comments_by_like: 0.25146198830409355,
        comments_rate: 0.019612314709236033,
      },
      obtidoEm: '2023-08-18T15:01:09.842Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 342,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18090132481348424/video_namelandre_18090132481348424.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18090132481348424/video_namelandre_18090132481348424.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64c1515e9166f2a3b9768942',
      origem: 'instagram',
      uid: '17998970290956919',
      __v: 0,
      ad: false,
      comentarios: 67,
      criadoEm: '2023-07-26T16:59:52.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17998970290956919/image_namelandre_17998970290956919.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17998970290956919/image_namelandre_17998970290956919.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17998970290956919/image_namelandre_17998970290956919.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.910Z',
      legenda:
        'Vlogzinho do primeiro jogo da seleção brasileira na copa do mundo de futebol feminino e claro pedi aquele cafezão da manhã pela @rappibrasil O Super App Oficial das Seleções Brasileiras pra acompanhar. Estamos prontos para ver as mulheres do Brasil fazendo história e conquistando o primeiro título da seleção feminina em 2023. Acorde cedo, peça seu café da manhã pelo app e e assista a seleção jogar! Use o cupom “AcordaPraElas” pra um mês de Prime gratuito! E aih quem arrisca o placar do próximo jogo das nossas meninas? #AcordaPraElas',
      link: 'https://www.instagram.com/reel/CvKwwI_vFaI/',
      links: [],
      mentions: ['rappibrasil'],
      metadados: {
        idFacebook: '17998970290956919',
        isEstimated: true,
        engagement: 222,
        plays: 4738,
        saved: 6,
        reach: 4560,
        effective_reach: 0.0871759577884836,
        tax_engagement: 0.04685521317011397,
        comments_by_like: 0.44966442953020136,
        comments_rate: 0.014140987758547911,
      },
      obtidoEm: '2023-08-18T15:01:09.910Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: ['AcordaPraElas'],
      tipo: 'video',
      upvotes: 149,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17998970290956919/video_namelandre_17998970290956919.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17998970290956919/video_namelandre_17998970290956919.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64bc27779166f2a3b96d7fee',
      origem: 'instagram',
      uid: '18060281143425867',
      __v: 0,
      ad: false,
      comentarios: 88,
      criadoEm: '2023-07-22T18:59:45.000Z',
      errorType: 'copyright',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18060281143425867/image_namelandre_18060281143425867.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18060281143425867/image_namelandre_18060281143425867.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18060281143425867/image_namelandre_18060281143425867.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:09.990Z',
      legenda: '+ um fit check mãe e filho, aprovado madrinstas? 🫶🏼',
      link: 'https://www.instagram.com/reel/CvArUZ2JoNx/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '18060281143425867',
        isEstimated: true,
        engagement: 1389,
        plays: 9542,
        saved: 21,
        reach: 8407,
        effective_reach: 0.16072111340521528,
        tax_engagement: 0.14556696709285266,
        comments_by_like: 0.06875,
        comments_rate: 0.009222385244183609,
      },
      obtidoEm: '2023-08-18T15:01:09.990Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 1280,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64aedcaebdd7aa41dc9da036',
      origem: 'instagram',
      uid: '18267908752152787',
      __v: 0,
      ad: true,
      comentarios: 85,
      criadoEm: '2023-07-12T16:43:35.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18267908752152787/image_namelandre_18267908752152787.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18267908752152787/image_namelandre_18267908752152787.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18267908752152787/image_namelandre_18267908752152787.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.064Z',
      legenda:
        'Fui conhecer a nova loja da @sonedaperfumaria que fica na paulista e conta com + de 40 lojas por todo Brasil. O espaço entrega um infinito de produtos, conceito clean beauty e um momento de desconexão com rooftop e área verde. Acesse o site e conheça o Clube de Benefícios exclusivos da Soneda, que dá acesso a vantagens, ofertas e brindes exclusivos e personalizados de acordo com o histórico de compras de cada cliente. #sonedacasadabeleza *publi',
      link: 'https://www.instagram.com/reel/CumrsUGsAO0/',
      links: [],
      mentions: ['sonedaperfumaria'],
      metadados: {
        idFacebook: '18267908752152787',
        isEstimated: true,
        engagement: 521,
        plays: 9736,
        saved: 46,
        reach: 9107,
        effective_reach: 0.1741033876271316,
        tax_engagement: 0.05351273623664749,
        comments_by_like: 0.21794871794871795,
        comments_rate: 0.008730484798685292,
      },
      obtidoEm: '2023-08-18T15:01:10.064Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: ['sonedacasadabeleza'],
      tipo: 'video',
      upvotes: 390,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18267908752152787/video_namelandre_18267908752152787.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18267908752152787/video_namelandre_18267908752152787.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64ab04b6bdd7aa41dcad28ce',
      origem: 'instagram',
      uid: '17993575304063330',
      __v: 0,
      ad: true,
      comentarios: 56,
      criadoEm: '2023-07-09T18:52:10.000Z',
      errorType: 'copyright',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993575304063330/image_namelandre_17993575304063330.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993575304063330/image_namelandre_17993575304063330.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993575304063330/image_namelandre_17993575304063330.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.146Z',
      legenda: 'eu convenci um adolescente a fazer fit check cmg no aeroporto. essa eh a thread.',
      link: 'https://www.instagram.com/reel/CufMGPKJLAa/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '17993575304063330',
        isEstimated: true,
        engagement: 1069,
        plays: 10526,
        saved: 13,
        reach: 8352,
        effective_reach: 0.1596696490020647,
        tax_engagement: 0.10155804674140224,
        comments_by_like: 0.056,
        comments_rate: 0.005320159604788144,
      },
      obtidoEm: '2023-08-18T15:01:10.146Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 1000,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-dev/default/copyright-error.png',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '649ca84d4218f76d19388320',
      origem: 'instagram',
      uid: '17999515375909925',
      __v: 0,
      ad: false,
      comentarios: 171,
      criadoEm: '2023-06-28T21:28:32.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17999515375909925/image_namelandre_17999515375909925.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17999515375909925/image_namelandre_17999515375909925.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17999515375909925/image_namelandre_17999515375909925.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.251Z',
      legenda:
        'Rapaiz, tá certo isso? Eu tenho oficialmente um adolescente de aparelho fixo. Assiste até o final pra ver a reação do Nick qd se viu. 🗣 Obrigada @yesodonto e @drajuprenassi pelos cuidados de sempre e agora nessa nova fase. 🫶🏼',
      link: 'https://www.instagram.com/reel/CuDJIrevsmR/',
      links: [],
      mentions: ['yesodonto', 'drajuprenassi'],
      metadados: {
        idFacebook: '17999515375909925',
        isEstimated: true,
        engagement: 1576,
        plays: 15403,
        saved: 10,
        reach: 13247,
        effective_reach: 0.2532499808824654,
        tax_engagement: 0.10231773031227683,
        comments_by_like: 0.12258064516129032,
        comments_rate: 0.01110173342855288,
      },
      obtidoEm: '2023-08-18T15:01:10.251Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 1395,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17999515375909925/video_namelandre_17999515375909925.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17999515375909925/video_namelandre_17999515375909925.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '649485204218f76d199e11b2',
      origem: 'instagram',
      uid: '17970870815268380',
      __v: 0,
      ad: false,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_0_namelandre_17970870815268380.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_1_namelandre_17970870815268380.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_2_namelandre_17970870815268380.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_3_namelandre_17970870815268380.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_4_namelandre_17970870815268380.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_5_namelandre_17970870815268380.jpg',
        },
        {
          tipo: 'video',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/carousel_6_namelandre_17970870815268380.mp4',
        },
      ],
      comentarios: 14,
      criadoEm: '2023-06-22T17:01:36.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/image_namelandre_17970870815268380.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/image_namelandre_17970870815268380.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17970870815268380/image_namelandre_17970870815268380.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.331Z',
      legenda: 'Dumpzinho de bons momentos. ❤️✨',
      link: 'https://www.instagram.com/p/CtzN-drLpdQ/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '17970870815268380',
        isEstimated: false,
        engagement: 242,
        saved: 4,
        impressions: 2200,
        reach: 1865,
        effective_reach: 0.03565420203410568,
        tax_engagement: 0.11,
        comments_by_like: 0.0625,
        comments_rate: 0.006363636363636364,
      },
      obtidoEm: '2023-08-18T15:01:10.331Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 224,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '6488fc294218f76d19b0104b',
      origem: 'instagram',
      uid: '17968942682428116',
      __v: 0,
      ad: false,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/carousel_0_namelandre_17968942682428116.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/carousel_1_namelandre_17968942682428116.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/carousel_2_namelandre_17968942682428116.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/carousel_3_namelandre_17968942682428116.jpg',
        },
      ],
      comentarios: 41,
      criadoEm: '2023-06-13T23:18:07.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/image_namelandre_17968942682428116.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/image_namelandre_17968942682428116.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17968942682428116/image_namelandre_17968942682428116.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.415Z',
      legenda: 'uns retratos bonitos que a minha amiga \nfez pra mim. ❤️',
      link: 'https://www.instagram.com/p/Ctct6UiNKKW/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '17968942682428116',
        isEstimated: false,
        engagement: 394,
        saved: 3,
        impressions: 3629,
        reach: 3259,
        effective_reach: 0.06230404527032194,
        tax_engagement: 0.10856985395425738,
        comments_by_like: 0.11714285714285715,
        comments_rate: 0.011297878203361807,
      },
      obtidoEm: '2023-08-18T15:01:10.414Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 350,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '648619de4218f76d1909c4f3',
      origem: 'instagram',
      uid: '18293212078107741',
      __v: 0,
      ad: false,
      comentarios: 27,
      criadoEm: '2023-06-11T18:49:51.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18293212078107741/image_namelandre_18293212078107741.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18293212078107741/image_namelandre_18293212078107741.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18293212078107741/image_namelandre_18293212078107741.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.504Z',
      legenda:
        'um dia comigo na NBA House. Assiste até o final pra ver a diferença do tamanho da minha mão pra mão de um jogador da NBA Academy. 🗣 #nbahouse',
      link: 'https://www.instagram.com/reel/CtXFcRUJsGG/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '18293212078107741',
        isEstimated: true,
        engagement: 304,
        plays: 4850,
        saved: 6,
        reach: 4135,
        effective_reach: 0.0790510055823201,
        tax_engagement: 0.06268041237113402,
        comments_by_like: 0.0996309963099631,
        comments_rate: 0.00556701030927835,
      },
      obtidoEm: '2023-08-18T15:01:10.504Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: ['nbahouse'],
      tipo: 'video',
      upvotes: 271,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18293212078107741/video_namelandre_18293212078107741.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/18293212078107741/video_namelandre_18293212078107741.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '647e85ccb7c765fbd1d7c19e',
      origem: 'instagram',
      uid: '17993075717003868',
      __v: 0,
      ad: false,
      carousel: [
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/carousel_0_namelandre_17993075717003868.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/carousel_1_namelandre_17993075717003868.jpg',
        },
        {
          tipo: 'video',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/carousel_2_namelandre_17993075717003868.mp4',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/carousel_3_namelandre_17993075717003868.jpg',
        },
        {
          tipo: 'imagem',
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/carousel_4_namelandre_17993075717003868.jpg',
        },
      ],
      comentarios: 51,
      criadoEm: '2023-06-06T00:35:48.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/image_namelandre_17993075717003868.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/image_namelandre_17993075717003868.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17993075717003868/image_namelandre_17993075717003868.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.588Z',
      legenda: 'a adolescente 30+ que habita em mim chorou. arrasta pro lado que tem vídeo, foi épico. 🥹',
      link: 'https://www.instagram.com/p/CtIQcOct6Dh/',
      links: [],
      mentions: [],
      metadados: {
        idFacebook: '17993075717003868',
        isEstimated: false,
        engagement: 988,
        saved: 6,
        impressions: 5815,
        reach: 5121,
        effective_reach: 0.09790089470061941,
        tax_engagement: 0.1699054170249355,
        comments_by_like: 0.05477980665950591,
        comments_rate: 0.008770421324161651,
      },
      obtidoEm: '2023-08-18T15:01:10.588Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'carousel',
      upvotes: 931,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
    },
    {
      _id: '647911fcb7c765fbd120c6c2',
      origem: 'instagram',
      uid: '17903430662719408',
      __v: 0,
      ad: false,
      comentarios: 173,
      criadoEm: '2023-06-01T21:40:42.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17903430662719408/image_namelandre_17903430662719408.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17903430662719408/image_namelandre_17903430662719408.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17903430662719408/image_namelandre_17903430662719408.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.684Z',
      legenda:
        'O Nick e a @sallve se uniram pra apresentar pra vcs o Kit Basicão Antiacne: limpador facial, tônico e sérum pra cuidar da pele oleosa e com tendência a espinhas e cravos, tanto de adolescentes como de adultos. O Kit contendo os 03 produtos da rotina diaria está com desconto de R$50 com o cupom ANTIACNE50 + frete grátis. Corre pro site! 💚',
      link: 'https://www.instagram.com/reel/Cs9pLKsP1S0/',
      links: [],
      mentions: ['sallve'],
      metadados: {
        idFacebook: '17903430662719408',
        isEstimated: true,
        engagement: 725,
        plays: 5721,
        saved: 15,
        reach: 4754,
        effective_reach: 0.0908847595014147,
        tax_engagement: 0.12672609683621744,
        comments_by_like: 0.3221601489757914,
        comments_rate: 0.03023946862436637,
      },
      obtidoEm: '2023-08-18T15:01:10.684Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: [],
      tipo: 'video',
      upvotes: 537,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17903430662719408/video_namelandre_17903430662719408.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17903430662719408/video_namelandre_17903430662719408.mp4',
          width: 480,
          height: 480,
        },
      },
    },
    {
      _id: '64754051b7c765fbd111088f',
      origem: 'instagram',
      uid: '17846737025983112',
      __v: 0,
      ad: true,
      comentarios: 79,
      criadoEm: '2023-05-30T00:04:44.000Z',
      imagens: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17846737025983112/image_namelandre_17846737025983112.jpg',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17846737025983112/image_namelandre_17846737025983112.jpg',
          width: 320,
          height: 320,
        },
        thumbnail: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17846737025983112/image_namelandre_17846737025983112.jpg',
          width: 150,
          height: 150,
        },
      },
      lastUpdate: '2023-08-18T15:01:10.758Z',
      legenda:
        'A atendente da @ohminhasvitaminas tá de volta pra te ensinar como responder o quiz e descobrir qual a suplementação ideal pra vc. São mais de 40 tipos de vitaminas, pra pele, cabelo, qualidade do sono, emagrecimento, aproveita pra usar meu cupom “NAMELANDRE” pra um super desconto de 30% até o dia 31/5. #ohminhavitaminas ✨ *publicidade',
      link: 'https://www.instagram.com/reel/Cs2LJm6OkX8/',
      links: [],
      mentions: ['ohminhasvitaminas'],
      metadados: {
        idFacebook: '17846737025983112',
        isEstimated: true,
        engagement: 403,
        plays: 7087,
        saved: 9,
        reach: 6859,
        effective_reach: 0.13112716984017742,
        tax_engagement: 0.05686468181176803,
        comments_by_like: 0.2507936507936508,
        comments_rate: 0.011147170876252293,
      },
      obtidoEm: '2023-08-18T15:01:10.758Z',
      obtidoPor: 'facebook',
      referencias: [],
      tags: ['ohminhavitaminas'],
      tipo: 'video',
      upvotes: 315,
      usuario: {
        id: 'instagram|17841400347220434',
        username: 'namelandre',
        foto: 'https://scontent-lcy1-1.xx.fbcdn.net/v/t51.2885-15/343128868_915057086248883_4762274712864479598_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=86c713&_nc_ohc=tBRHV9YZcwsAX_SLdq7&_nc_ht=scontent-lcy1-1.xx&edm=AL-3X8kEAAAA&oh=00_AfCM2L3TVc7cUnJ-wXnzd7UUHFrgVrJ1EqQue7m7mizo9w&oe=64E3A454',
        nome: 'Nathália Melandre',
      },
      videos: {
        resolucaoPadrao: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17846737025983112/video_namelandre_17846737025983112.mp4',
          width: 640,
          height: 640,
        },
        resolucaoMedia: {
          url: 'https://storage.googleapis.com/squid-story/17841400347220434/17846737025983112/video_namelandre_17846737025983112.mp4',
          width: 480,
          height: 480,
        },
      },
    },
  ],
  hasNextPage: true,
}
